import React, { useState, useEffect, useRef } from "react";
import { Grid, Typography, Container, Link, Button, Card, CardContent, CardMedia, Box, Chip, TextField, InputAdornment, Menu, MenuItem } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import ModernFooter from "../../pages/home/ModernFooter";
import { FormControl, InputLabel, Select } from "@material-ui/core";
import ParkService from "../dashboard/Locality/Service/parkService";
import ClinicService from "../dashboard/Locality/Service/clinicService";
import BranchService from "../dashboard/Locality/Service/branchService";
import ExbhitionService from "../dashboard/Locality/Service/exbhitionService";
import UserService from "../dashboard/Locality/Service/userService";
import AdminEventService from "../dashboard/Locality/Service/adminEventService";
import SRI from './images/SRI.jpg';
import logo from './images/logo.png';
import halloween from './images/Halloween_BMS_cover-Image (1).jpg';
import parkImage from './images/park.jpg';
import bankImage from './images/bank.jpg';
import doctorImage from './images/Doctor.jpg';
import strapImage from './images/Strap.png';
// Material-UI Icons
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import SecurityIcon from '@material-ui/icons/Security';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import CropFreeIcon from '@material-ui/icons/CropFree';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import LockIcon from '@material-ui/icons/Lock';
import HeadsetMicIcon from '@material-ui/icons/HeadsetMic';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import PaymentIcon from '@material-ui/icons/Payment';
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import SearchIcon from '@material-ui/icons/Search';
import AssessmentIcon from '@material-ui/icons/Assessment';
import SendIcon from '@material-ui/icons/Send';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import LocalMoviesIcon from '@material-ui/icons/LocalMovies';
import EventIcon from '@material-ui/icons/Event';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import ArtTrackIcon from '@material-ui/icons/ArtTrack';
import FilterListIcon from '@material-ui/icons/FilterList';
import './styles/bootstrap.min.css';
import './styles/animate.css';

import './styles/tiny-slider.css';
import './styles/glightbox.min.css';
import './styles/main.css';
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    heroSection: {
        background: 'linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)',
        padding: '100px 0 80px 0',
        position: 'relative',
        overflow: 'hidden',
        minHeight: '600px',
        [theme.breakpoints.down('sm')]: {
            padding: '60px 0 40px 0',
            minHeight: 'auto',
        }
    },
    heroCard: {
        backgroundColor: 'white',
        borderRadius: '24px',
        padding: '40px',
        boxShadow: '0 10px 40px rgba(0,0,0,0.12)',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            padding: '20px',
            borderRadius: '16px',
            marginTop: '20px',
        }
    },
    searchBar: {
        backgroundColor: 'white',
        borderRadius: '30px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        marginBottom: '30px',
        maxWidth: '600px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '20px',
            '& .MuiOutlinedInput-input': {
                padding: '12px 16px',
                fontSize: '14px',
            }
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: '30px',
            backgroundColor: 'white',
            '& fieldset': {
                border: 'none',
                borderRadius: '30px',
            },
            '&:hover fieldset': {
                border: 'none',
            },
            '&.Mui-focused fieldset': {
                border: 'none',
                borderRadius: '30px',
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: '16px 20px',
            fontSize: '16px',
        }
    },
    searchResults: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        marginTop: '8px',
        maxHeight: '400px',
        overflowY: 'auto',
        zIndex: 1000,
    },
    searchResultItem: {
        padding: '12px 20px',
        cursor: 'pointer',
        borderBottom: '1px solid #f0f0f0',
        transition: 'background-color 0.2s',
        '&:hover': {
            backgroundColor: '#f5f5f5',
        },
        '&:last-child': {
            borderBottom: 'none',
        }
    },
    serviceCard: {
        height: '100%',
        borderRadius: '16px',
        transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        border: '1px solid rgba(0,0,0,0.05)',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '20px',
        },
        '&:hover': {
            transform: 'translateY(-12px) scale(1.02)',
            boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
            borderColor: '#1976d2',
            '& $serviceCardMedia': {
                transform: 'scale(1.1)',
            }
        }
    },
    serviceCardMedia: {
        height: '220px',
        width: '100%',
        objectFit: 'cover',
        transition: 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            height: '180px',
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.1) 100%)',
            opacity: 0,
            transition: 'opacity 0.3s ease',
        }
    },
    serviceCardContent: {
        padding: '24px',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
    },
    serviceCardTitle: {
        fontWeight: 'bold',
        marginBottom: '12px',
        fontSize: '20px',
        color: '#1a1a1a',
        fontFamily: '"DM Sans", sans-serif',
    },
    heading: {
        fontFamily: '"DM Sans", sans-serif',
        fontWeight: 'bold',
    },
    serviceCardDescription: {
        color: '#666',
        marginBottom: '20px',
        lineHeight: '1.6',
        fontSize: '14px',
    },
    serviceCardButton: {
        backgroundColor: 'rgb(112, 57, 177)',
        color: 'white',
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: '20px',
        padding: '12px 24px',
        transition: 'all 0.3s ease',
        boxShadow: '0 4px 12px rgba(255, 107, 129, 0.3)',
        marginTop: 'auto',
        '&:hover': {
            backgroundColor: '#7039b1',
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 20px rgba(255, 107, 129, 0.4)',
        }
    },
    formControl: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            transition: 'all 0.3s ease',
            '&:hover': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#1976d2',
                }
            },
            '&.Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#1976d2',
                    borderWidth: '2px',
                }
            }
        },
        '& .MuiInputLabel-root': {
            '&.Mui-focused': {
                color: '#1976d2',
            }
        }
    },
    stepCard: {
        textAlign: 'center',
        padding: '30px 20px',
        borderRadius: '12px',
        height: '100%',
        backgroundColor: 'white',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        transition: 'all 0.3s ease',
        transform: 'translateY(0)',
        opacity: 1,
        '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '20px 15px',
            marginBottom: '20px',
        }
    },
    stepNumber: {
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        backgroundColor: '#1976d2',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 20px',
        fontSize: '24px',
        fontWeight: 'bold',
    },
    featureCard: {
        padding: '30px',
        borderRadius: '12px',
        textAlign: 'center',
        height: '100%',
        backgroundColor: '#fff',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        transition: 'all 0.3s ease',
        transform: 'translateY(0)',
        opacity: 1,
        cursor: 'pointer',
        '&:hover': {
            transform: 'translateY(-8px) scale(1.02)',
            boxShadow: '0 8px 24px rgba(25, 118, 210, 0.2)',
            '& .featureIcon': {
                transform: 'scale(1.1) rotate(5deg)',
            }
        },
    },
    ctaSection: {
        background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
        padding: '80px 0',
        color: 'white',
    },
    primaryBtn: {
        backgroundColor: '#1976d2',
        color: 'white',
        padding: '14px 40px',
        borderRadius: '30px',
        textTransform: 'none',
        fontSize: '16px',
        fontWeight: 600,
        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
        [theme.breakpoints.down('sm')]: {
            padding: '12px 24px',
            fontSize: '14px',
            width: '100%',
        },
        '&:hover': {
            backgroundColor: '#1565c0',
            boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
        }
    },
    secondaryBtn: {
        backgroundColor: 'white',
        color: '#1976d2',
        padding: '14px 40px',
        borderRadius: '30px',
        textTransform: 'none',
        fontSize: '16px',
        fontWeight: 600,
        border: '2px solid #1976d2',
        '&:hover': {
            backgroundColor: '#f5f5f5',
        }
    },
    statCard: {
        textAlign: 'center',
        padding: '20px',
    },
    horizontalScroll: {
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    },
}));
function Home(props) {
    var classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const [parkList, setParkList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [clinicList, setClinicList] = useState([]);
    const [exbhitionList, setExbhitionList] = useState([]);
    const [eventList, setEventList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [parkId, setParkId] = useState("");
    const [clinicId, setClinicId] = useState("");
    const [branchId, setBranchId] = useState("");
    const [exbhitionId, setExbhitionId] = useState("");
    const [branchName, setBranchName] = useState("");
    const [clinicName, setClinicName] = useState("");
    const [organizationName, setOrganizationName] = useState("");
    var [isLoading, setIsLoading] = useState(false);
    var [error, setError] = useState(null);
    var [activeTabId, setActiveTabId] = useState(0);
    var [loginValue, setLoginValue] = useState("");
    var [passwordValue, setPasswordValue] = useState("");
    var [roleValue, setRoleValue] = useState("");
    const [parkName, setParkName] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [showSearchResults, setShowSearchResults] = useState(false);
    const [selectedSearchResult, setSelectedSearchResult] = useState(null);
    const [categoryMenuAnchor, setCategoryMenuAnchor] = useState(null);
    const [cityMenuAnchor, setCityMenuAnchor] = useState(null);
    const [venueMenuAnchor, setVenueMenuAnchor] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState(null);
    const [showFilters, setShowFilters] = useState(false);
    
    const handleSearch = (query) => {
        setSearchQuery(query);
        
        // Clear selected result when user types
        if (selectedSearchResult) {
            setSelectedSearchResult(null);
        }
        
        if (query.trim() === "") {
            setSearchResults([]);
            setShowSearchResults(false);
            return;
        }
        
        const results = [];
        const lowerQuery = query.toLowerCase();
        
        // Search in parks
        if (parkList && Array.isArray(parkList)) {
            parkList.forEach(park => {
                if (park.parkName && park.parkName.toLowerCase().includes(lowerQuery)) {
                    results.push({ type: 'Park', name: park.parkName, id: park._id, data: park });
                }
            });
        }
        
        // Search in clinics
        if (clinicList && Array.isArray(clinicList)) {
            clinicList.forEach(clinic => {
                if (clinic.clinicName && clinic.clinicName.toLowerCase().includes(lowerQuery)) {
                    results.push({ type: 'Clinic', name: clinic.clinicName, id: clinic._id, data: clinic });
                }
            });
        }
        
        // Search in branches
        if (branchList && Array.isArray(branchList)) {
            branchList.forEach(branch => {
                if (branch.branchName && branch.branchName.toLowerCase().includes(lowerQuery)) {
                    results.push({ type: 'Bank Branch', name: branch.branchName, id: branch._id, data: branch });
                }
            });
        }
        
        // Search in events
        if (eventList && Array.isArray(eventList)) {
            eventList.forEach(event => {
                if (event.eventName && event.eventName.toLowerCase().includes(lowerQuery)) {
                    results.push({ type: 'Event', name: event.eventName, id: event._id, data: event });
                }
            });
        }
        
        setSearchResults(results);
        setShowSearchResults(results.length > 0);
    };
    
    const handleSearchResultClick = (result) => {
        setSelectedSearchResult(result);
        setSearchQuery(result.name);
        setShowSearchResults(false);
    };

    const handleBuyTicket = () => {
        if (selectedSearchResult) {
            if (selectedSearchResult.type === 'Park') {
                props.history.push(`/ticketbooking/${selectedSearchResult.id}/${selectedSearchResult.data.parkName.toLowerCase()}`);
            } else if (selectedSearchResult.type === 'Clinic') {
                props.history.push(`/doctorbooking/${selectedSearchResult.id}/${selectedSearchResult.data.clinicName.toLowerCase()}`);
            } else if (selectedSearchResult.type === 'Bank Branch') {
                props.history.push(`/loanbooking/${selectedSearchResult.id}/${selectedSearchResult.data.branchName.toLowerCase()}`);
            } else if (selectedSearchResult.type === 'Event') {
                props.history.push(`/event/${selectedSearchResult.id}`);
            }
            setSearchQuery("");
            setSearchResults([]);
            setShowSearchResults(false);
            setSelectedSearchResult(null);
        } else {
            // If no item selected, redirect to profile registration
            handleChange();
        }
    };
    
    const handleOpen = () => {
        props.history.push('/login')
    };
    const handleChange = () => {
        props.history.push('/profileregistration')
    }
    const handleLogin = () => {
        props.history.push('/branchuser')
    }
    const handleUser = () => {
        props.history.push('/inspectorlogin')
    }
    const handleTermsConditions = () => {
        props.history.push('/termsconditions')
    }
    const handleRefundPolicy = () => {
        props.history.push('/refundpolicy')
    }
    const handlePrivacyPolicy = () => {
        props.history.push('/privacypolicy')
    }
    const handleEvents = () => {
        props.history.push('/events')
    }
    const handleServicesClick = (e) => {
        e.preventDefault();
        const servicesSection = document.getElementById('services');
        if (servicesSection) {
            const headerOffset = 100; // Adjust based on your header height
            const elementPosition = servicesSection.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }
    const handleHowItWorksClick = (e) => {
        e.preventDefault();
        const section = document.getElementById('how-it-works');
        if (section) {
            const headerOffset = 100;
            const elementPosition = section.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }
    const handleFeaturesClick = (e) => {
        e.preventDefault();
        const section = document.getElementById('features');
        if (section) {
            const headerOffset = 100;
            const elementPosition = section.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }
    useEffect(() => {
        getParkList();
        getClinicList();
        getBranchList();
        getExbhitionList();
        getEventList();
        return () => {
            setParkList([]);
            setClinicList([]);
            setBranchList([]);
            setExbhitionList([]);
            setEventList([]);
            setUserList([]);
        }
    }, []);
    const getParkList = () => {
        ParkService.getAllActivePark({status:true}).then((res) => {
            if (res && Array.isArray(res)) {
                // Sort parks to put "86th All India industrial exhibition 2026" at the top
                const sortedParks = [...res].sort((a, b) => {
                    const targetPark = "86th All India industrial exhibition 2026";
                    if (a.parkName === targetPark) return -1;
                    if (b.parkName === targetPark) return 1;
                    return 0;
                });
                setParkList(sortedParks);
            } else {
                setParkList([]);
            }
        }).catch((err) => {
            console.error('Error fetching parks:', err);
            setParkList([]);
        });
    }
    const getClinicList = () => {
        ClinicService.getAllClinic().then((res) => {
            setClinicList(res);

        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getBranchList = () => {
        BranchService.getAllBranch().then((res) => {
            setBranchList(res);

        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getExbhitionList = () => {
        ExbhitionService.getAllExbhition().then((res) => {
            setExbhitionList(res);

        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getEventList = () => {
        AdminEventService.getAllAdminEvent().then((res) => {
            // Filter only active events
            const activeEvents = (res || []).filter(event => event.status === 'active');
            setEventList(activeEvents);
        }).catch((err) => {
            // setError(err.message);
        });
    }
  
    const [isOpen, setIsOpen] = React.useState(false);
    const [loginDropdownOpen, setLoginDropdownOpen] = useState(false);
    const loginDropdownRef = useRef(null);

    const toggleNavbar = () => {
        setIsOpen(!isOpen);
    };

    const toggleLoginDropdown = () => {
        setLoginDropdownOpen(!loginDropdownOpen);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (loginDropdownRef.current && !loginDropdownRef.current.contains(event.target)) {
                setLoginDropdownOpen(false);
            }
        };

        if (loginDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [loginDropdownOpen]);
    const handleRedirect = () => {

        props.history.push(`ticketbooking/${parkId}/${parkName}`)
    };
    const handleRedirectDoctor = () => {

        props.history.push(`doctorbooking/${clinicId}/${clinicName}`)
    };
    const handleRedirectBranch = () => {

        props.history.push(`loanbooking/${branchId}/${branchName}`)
    };
    const handleRedirectExbhition = () => {

        props.history.push(`exbhitionbooking/${exbhitionId}/${organizationName}`)
    };
    return (
        <>
            <style>
                {`
                    @keyframes fadeInUp {
                        from {
                            opacity: 0;
                            transform: translateY(30px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }
                    @keyframes scaleIn {
                        from {
                            opacity: 0;
                            transform: scale(0.8);
                        }
                        to {
                            opacity: 1;
                            transform: scale(1);
                        }
                    }
                    .parallax-section {
                        position: relative;
                        background-attachment: fixed;
                        background-position: center;
                        background-repeat: no-repeat;
                        background-size: cover;
                        min-height: 400px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .parallax-overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background: rgba(13, 59, 102, 0.7);
                        z-index: 1;
                    }
                    .parallax-content {
                        position: relative;
                        z-index: 2;
                        color: white;
                        text-align: center;
                        padding: 40px 20px;
                    }
                    @media (max-width: 768px) {
                        .parallax-section {
                            background-attachment: scroll;
                            min-height: 300px;
                        }
                    }
                `}
            </style>
            <header class="header navbar-area sticky">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-12">
                            <div class="nav-inner">
                                <nav class="navbar navbar-expand-lg" style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <a class="navbar-brand" href="index.html" style={{ display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none' }}>
                                        <img src={SRI} alt="some example image" style={{ height: "70px", width: "70px", backgroundColor:'white' }} />
                                        {/* <span style={{ 
                                            fontSize: '28px', 
                                            fontFamily: '"DM Sans", sans-serif',
                                fontWeight: 'bold', 
                                            color: 'rgb(112, 57, 177)',
                                            letterSpacing: '1px',
                                            fontFamily: 'Arial, sans-serif',
                                            textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                        }}>
                                            SRIQR.com
                                        </span> */}
                                    <img src={logo} alt="some example image" style={{ height: "70px", width: "auto", backgroundColor:'white' }} />

                                    </a>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                    <button class="navbar-toggler mobile-menu-btn" onClick={toggleNavbar} type="button" data-bs-toggle="collapse"
                                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                        aria-expanded="false" aria-label="Toggle navigation">
                                        <span class="toggler-icon"></span>
                                        <span class="toggler-icon"></span>
                                        <span class="toggler-icon"></span>
                                    </button>
                                    {/* <div className="dropdown" ref={loginDropdownRef} style={{ position: 'relative', display: isOpen ? 'none' : 'block' }}>
                                        <Button
                                            variant="outlined"
                                            onClick={toggleLoginDropdown}
                                            style={{ 
                                                backgroundColor: '#ffffff', 
                                                color: '#1976d2',
                                                border: '2px solid #1976d2',
                                                padding: '8px 20px',
                                                borderRadius: '40px',
                                                cursor: 'pointer',
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                textTransform: 'none',
                                                transition: 'all 0.3s ease',
                                                boxShadow: '0 4px 12px rgba(25, 118, 210, 0.2)',
                                                minWidth: '100px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = '#1976d2';
                                                e.target.style.color = '#ffffff';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = '#ffffff';
                                                e.target.style.color = '#1976d2';
                                            }}
                                        >
                                            Login
                                        </Button>
                                        {loginDropdownOpen && (
                                            <div 
                                                className="dropdown-menu show" 
                                                style={{ 
                                                    position: 'absolute', 
                                                    right: 0, 
                                                    top: '100%',
                                                    minWidth: '180px',
                                                    zIndex: 1000,
                                                    backgroundColor: 'white',
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                    borderRadius: '8px',
                                                    padding: '8px 0',
                                                    marginTop: '8px'
                                                }}
                                            >
                                                <a 
                                                    className="dropdown-item" 
                                                    href="javascript:void(0)" 
                                                    onClick={() => {
                                                        handleOpen();
                                                        setLoginDropdownOpen(false);
                                                    }}
                                                    style={{ 
                                                        padding: '12px 20px', 
                                                        display: 'block',
                                                        color: '#333',
                                                        textDecoration: 'none',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        transition: 'background-color 0.2s'
                                                    }}
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                                >
                                                    Client Login
                                                </a>
                                                <a 
                                                    className="dropdown-item" 
                                                    href="javascript:void(0)" 
                                                    onClick={() => {
                                                        handleLogin();
                                                        setLoginDropdownOpen(false);
                                                    }}
                                                    style={{ 
                                                        padding: '12px 20px', 
                                                        display: 'block',
                                                        color: '#333',
                                                        textDecoration: 'none',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        transition: 'background-color 0.2s'
                                                    }}
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                                >
                                                    Counter Login
                                                </a>
                                            </div>
                                        )}
                                    </div> */}
                                    </div>
                                    {isOpen ? (
                                        <div className="navbar-collapse sub-menu-bar" id="navbarSupportedContent">
                                            <ul id="nav" className="navbar-nav ms-auto">
                                                <li className="nav-item">
                                                    <a href="#home" className="page-scroll active" aria-label="Toggle navigation" style={{
                                                        position: 'relative',
                                                        transition: 'all 0.3s ease',
                                                        display: 'inline-block'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.color = '#1976d2';
                                                        e.target.style.transform = 'translateY(-2px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.color = '';
                                                        e.target.style.transform = 'translateY(0)';
                                                    }}
                                                    >Home</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="#services" onClick={handleServicesClick} className="page-scroll active" aria-label="Toggle navigation" style={{
                                                        position: 'relative',
                                                        transition: 'all 0.3s ease',
                                                        display: 'inline-block'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.color = '#1976d2';
                                                        e.target.style.transform = 'translateY(-2px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.color = '';
                                                        e.target.style.transform = 'translateY(0)';
                                                    }}
                                                    >Services</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleEvents} className="page-scroll active" style={{
                                                        position: 'relative',
                                                        transition: 'all 0.3s ease',
                                                        display: 'inline-block'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.color = '#1976d2';
                                                        e.target.style.transform = 'translateY(-2px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.color = '';
                                                        e.target.style.transform = 'translateY(0)';
                                                    }}
                                                    >Events</a>
                                                </li>
                                                {/* <li className="nav-item">
                                                    <a href="#how-it-works" onClick={handleHowItWorksClick} className="page-scroll active" aria-label="Toggle navigation" style={{
                                                        position: 'relative',
                                                        transition: 'all 0.3s ease',
                                                        display: 'inline-block'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.color = '#1976d2';
                                                        e.target.style.transform = 'translateY(-2px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.color = '';
                                                        e.target.style.transform = 'translateY(0)';
                                                    }}
                                                    >How It Works</a>
                                                </li> */}
                                                {/* <li className="nav-item">
                                                    <a href="#features" onClick={handleFeaturesClick} className="page-scroll active" aria-label="Toggle navigation" style={{
                                                        position: 'relative',
                                                        transition: 'all 0.3s ease',
                                                        display: 'inline-block'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.color = '#1976d2';
                                                        e.target.style.transform = 'translateY(-2px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.color = '';
                                                        e.target.style.transform = 'translateY(0)';
                                                    }}
                                                    >Features</a>
                                                </li> */}
                                                {/* <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleOpen} className="page-scroll active">Client Login</a>
                                                </li> */}
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleChange} className="page-scroll active" aria-label="Toggle navigation" style={{
                                                        position: 'relative',
                                                        transition: 'all 0.3s ease',
                                                        display: 'inline-block'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.color = '#1976d2';
                                                        e.target.style.transform = 'translateY(-2px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.color = '';
                                                        e.target.style.transform = 'translateY(0)';
                                                    }}
                                                    >Register Your Business</a>
                                                </li>
                                                <li className="nav-item" style={{ 
                                                    display: isMobile ? 'block' : 'none',
                                                    marginTop: '10px',
                                                    paddingTop: '10px',
                                                    borderTop: '1px solid rgba(0,0,0,0.1)'
                                                }}>
                                                    <div ref={loginDropdownRef} style={{ position: 'relative' }}>
                                                        <button
                                                            onClick={toggleLoginDropdown}
                                                            style={{
                                                                backgroundColor: '#1976d2',
                                                                color: '#ffffff',
                                                                border: 'none',
                                                                padding: '12px 24px',
                                                                borderRadius: '8px',
                                                                cursor: 'pointer',
                                                                fontSize: '16px',
                                                                fontWeight: 600,
                                                                width: '100%',
                                                                textAlign: 'center',
                                                                transition: 'all 0.3s ease',
                                                                boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                gap: '8px'
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.target.style.backgroundColor = '#1565c0';
                                                                e.target.style.transform = 'translateY(-2px)';
                                                                e.target.style.boxShadow = '0 4px 12px rgba(25, 118, 210, 0.4)';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.target.style.backgroundColor = '#1976d2';
                                                                e.target.style.transform = 'translateY(0)';
                                                                e.target.style.boxShadow = '0 2px 8px rgba(25, 118, 210, 0.3)';
                                                            }}
                                                        >
                                                            Login
                                                            <span style={{ 
                                                                transform: loginDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                                                transition: 'transform 0.3s ease',
                                                                display: 'inline-block'
                                                            }}>▼</span>
                                                        </button>
                                                        {loginDropdownOpen && (
                                                            <div style={{
                                                                position: 'absolute',
                                                                top: '100%',
                                                                left: 0,
                                                                right: 0,
                                                                marginTop: '8px',
                                                                backgroundColor: 'white',
                                                                borderRadius: '8px',
                                                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                                zIndex: 1000,
                                                                overflow: 'hidden'
                                                            }}>
                                                                <a
                                                                    href="javascript:void(0)"
                                                                    onClick={() => {
                                                                        handleOpen();
                                                                        setLoginDropdownOpen(false);
                                                                        setIsOpen(false);
                                                                    }}
                                                                    style={{
                                                                        padding: '14px 20px',
                                                                        display: 'block',
                                                                        color: '#333',
                                                                        textDecoration: 'none',
                                                                        cursor: 'pointer',
                                                                        fontSize: '15px',
                                                                        borderBottom: '1px solid #f0f0f0',
                                                                        transition: 'background-color 0.2s'
                                                                    }}
                                                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                                                >
                                                                    Client Login
                                                                </a>
                                                                <a
                                                                    href="javascript:void(0)"
                                                                    onClick={() => {
                                                                        handleLogin();
                                                                        setLoginDropdownOpen(false);
                                                                        setIsOpen(false);
                                                                    }}
                                                                    style={{
                                                                        padding: '14px 20px',
                                                                        display: 'block',
                                                                        color: '#333',
                                                                        textDecoration: 'none',
                                                                        cursor: 'pointer',
                                                                        fontSize: '15px',
                                                                        borderBottom: '1px solid #f0f0f0',
                                                                        transition: 'background-color 0.2s'
                                                                    }}
                                                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                                                >
                                                                    Counter Login
                                                                </a>
                                                                <a
                                                                    href="javascript:void(0)"
                                                                    onClick={() => {
                                                                        handleUser();
                                                                        setLoginDropdownOpen(false);
                                                                        setIsOpen(false);
                                                                    }}
                                                                    style={{
                                                                        padding: '14px 20px',
                                                                        display: 'block',
                                                                        color: '#333',
                                                                        textDecoration: 'none',
                                                                        cursor: 'pointer',
                                                                        fontSize: '15px',
                                                                        transition: 'background-color 0.2s'
                                                                    }}
                                                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                                                >
                                                                    Ticket Inspector
                                                                </a>
                                                            </div>
                                                        )}
                                                    </div>
                                                </li>
                                                {/* <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleLogin} className="page-scroll active" aria-label="Toggle navigation">Counter Login</a>
                                                </li> */}
                                                {/* <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleUser} className="page-scroll active">Ticket Inspector</a>
                                                </li> */}
                                                {/* <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleTermsConditions} className="page-scroll active">Terms & Conditions</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleRefundPolicy} className="page-scroll active">Refund Policy</a>
                                                </li> */}
                                                {/* <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handlePrivacyPolicy} className="page-scroll active">Privacy Policy</a>
                                                </li> */}
                                                
                                            </ul>
                                        </div>
                                    ) : (
                                        <div className="collapse navbar-collapse sub-menu-bar" id="navbarSupportedContent">
                                            <ul id="nav" className="navbar-nav ms-auto">
                                                <li className="nav-item">
                                                    <a href="#home" className="page-scroll active" aria-label="Toggle navigation" style={{
                                                        position: 'relative',
                                                        transition: 'all 0.3s ease',
                                                        display: 'inline-block'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.color = '#1976d2';
                                                        e.target.style.transform = 'translateY(-2px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.color = '';
                                                        e.target.style.transform = 'translateY(0)';
                                                    }}
                                                    >Home</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="#services" onClick={handleServicesClick} className="page-scroll active" aria-label="Toggle navigation" style={{
                                                        position: 'relative',
                                                        transition: 'all 0.3s ease',
                                                        display: 'inline-block'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.color = '#1976d2';
                                                        e.target.style.transform = 'translateY(-2px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.color = '';
                                                        e.target.style.transform = 'translateY(0)';
                                                    }}
                                                    >Services</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleEvents} className="page-scroll active" aria-label="Toggle navigation" style={{
                                                        position: 'relative',
                                                        transition: 'all 0.3s ease',
                                                        display: 'inline-block'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.color = '#1976d2';
                                                        e.target.style.transform = 'translateY(-2px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.color = '';
                                                        e.target.style.transform = 'translateY(0)';
                                                    }}
                                                    >Events</a>
                                                </li>
                                                {/* <li className="nav-item">
                                                    <a href="#how-it-works" onClick={handleHowItWorksClick} className="page-scroll active" aria-label="Toggle navigation" style={{
                                                        position: 'relative',
                                                        transition: 'all 0.3s ease',
                                                        display: 'inline-block'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.color = '#1976d2';
                                                        e.target.style.transform = 'translateY(-2px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.color = '';
                                                        e.target.style.transform = 'translateY(0)';
                                                    }}
                                                    >How It Works</a>
                                                </li> */}
                                                {/* <li className="nav-item">
                                                    <a href="#features" onClick={handleFeaturesClick} className="page-scroll active" aria-label="Toggle navigation" style={{
                                                        position: 'relative',
                                                        transition: 'all 0.3s ease',
                                                        display: 'inline-block'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.color = '#1976d2';
                                                        e.target.style.transform = 'translateY(-2px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.color = '';
                                                        e.target.style.transform = 'translateY(0)';
                                                    }}
                                                    >Features</a>
                                                </li> */}
                                                {/* <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleOpen} className="page-scroll active">Client Login</a>
                                                </li> */}
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleChange} className="page-scroll active" aria-label="Toggle navigation" style={{
                                                        position: 'relative',
                                                        transition: 'all 0.3s ease',
                                                        display: 'inline-block'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.color = '#1976d2';
                                                        e.target.style.transform = 'translateY(-2px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.color = '';
                                                        e.target.style.transform = 'translateY(0)';
                                                    }}
                                                    >Register Your Business</a>
                                                </li>
                                                {/* <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleLogin} className="page-scroll active" aria-label="Toggle navigation">Counter Login</a>
                                                </li> */}
                                                {/* <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleUser} className="page-scroll active" aria-label="Toggle navigation">Ticket Inspector</a>
                                                </li> */}
                                                {/* <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleTermsConditions} className="page-scroll active" aria-label="Toggle navigation">Terms & Conditions</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleRefundPolicy} className="page-scroll active" aria-label="Toggle navigation">Refund Policy</a>
                                                </li> */}
                                                {/* <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handlePrivacyPolicy} className="page-scroll active" aria-label="Toggle navigation">Privacy Policy</a>
                                                </li> */}
                                               
                                            </ul>
                                            <div className="dropdown" ref={loginDropdownRef} style={{ position: 'relative', marginLeft: '15px' }}>
                                                <Button
                                                    variant="outlined"
                                                    onClick={toggleLoginDropdown}
                                                    style={{ 
                                                        backgroundColor: '#ffffff', 
                                                        color: '#1976d2',
                                                        border: '2px solid #1976d2',
                                                        padding: '8px 20px',
                                                        borderRadius: '40px',
                                                        cursor: 'pointer',
                                                        fontSize: '16px',
                                                        fontWeight: 600,
                                                        textTransform: 'none',
                                                        transition: 'all 0.3s ease',
                                                        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.2)',
                                                        minWidth: '100px'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.backgroundColor = '#1976d2';
                                                        e.target.style.color = '#ffffff';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.backgroundColor = '#ffffff';
                                                        e.target.style.color = '#1976d2';
                                                    }}
                                                >
                                                    Login
                                                </Button>
                                                {loginDropdownOpen && (
                                                    <div 
                                                        className="dropdown-menu show" 
                                                        style={{ 
                                                            position: 'absolute', 
                                                            right: 0, 
                                                            top: '100%',
                                                            minWidth: '180px',
                                                            zIndex: 1000,
                                                            backgroundColor: 'white',
                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                            borderRadius: '8px',
                                                            padding: '8px 0',
                                                            marginTop: '8px'
                                                        }}
                                                    >
                                                        <a 
                                                            className="dropdown-item" 
                                                            href="javascript:void(0)" 
                                                            onClick={() => {
                                                                handleOpen();
                                                                setLoginDropdownOpen(false);
                                                            }}
                                                            style={{ 
                                                                padding: '12px 20px', 
                                                                display: 'block',
                                                                color: '#333',
                                                                textDecoration: 'none',
                                                                cursor: 'pointer',
                                                                fontSize: '14px',
                                                                transition: 'background-color 0.2s'
                                                            }}
                                                            onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                                        >
                                                            Client Login
                                                        </a>
                                                        <a 
                                                            className="dropdown-item" 
                                                            href="javascript:void(0)" 
                                                            onClick={() => {
                                                                handleLogin();
                                                                setLoginDropdownOpen(false);
                                                            }}
                                                            style={{ 
                                                                padding: '12px 20px', 
                                                                display: 'block',
                                                                color: '#333',
                                                                textDecoration: 'none',
                                                                cursor: 'pointer',
                                                                fontSize: '14px',
                                                                transition: 'background-color 0.2s'
                                                            }}
                                                            onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                                        >
                                                            Counter Login
                                                        </a>
                                                        <a 
                                                            className="dropdown-item" 
                                                            href="javascript:void(0)" 
                                                            onClick={() => {
                                                                handleUser();
                                                                setLoginDropdownOpen(false);
                                                            }}
                                                            style={{ 
                                                                padding: '12px 20px', 
                                                                display: 'block',
                                                                color: '#333',
                                                                textDecoration: 'none',
                                                                cursor: 'pointer',
                                                                fontSize: '14px',
                                                                transition: 'background-color 0.2s'
                                                            }}
                                                            onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                                        >
                                                            Ticket Inspector
                                                        </a>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {/* <div className="button add-list-button">
                                        <a href="javascript:void(0)" onClick={handleOpen} className="btn">aaAdmin Login</a>
                                    </div> */}
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* New Modern Hero Section with Parallax */}
            <Box 
                id="home" 
                style={{ 
                    backgroundImage: isMobile ? 'linear-gradient(90deg, #E8F1FF 0%, #F3F8FF 40%, #FFFFFF 100%)' : 'linear-gradient(135deg, rgba(232, 241, 255, 0.92) 0%, rgba(243, 248, 255, 0.92) 50%, rgba(255, 255, 255, 0.92) 100%), url(https://images.unsplash.com/photo-1511578314322-379afb476865?w=1920&h=1080&fit=crop&auto=format)',
                    backgroundAttachment: isMobile ? 'scroll' : 'fixed',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    padding: '100px 0 80px 0',
                    position: 'relative',
                    overflow: 'hidden',
                    minHeight: isMobile ? 'auto' : '600px'
                }}
            >
                <Container>
                    <Grid container spacing={4} alignItems="stretch" style={{ minHeight: isMobile ? 'auto' : '600px' }}>
                        {/* Left Section - Ticket Buyers */}
                        <Grid item xs={12} md={6} style={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            justifyContent: 'center',
                            padding: isMobile ? '40px 16px' : '60px 40px'
                        }}>
                            {/* Digital Ticketing Platform Tag */}
                            <Box style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                                <Box style={{ 
                                    backgroundColor: 'rgb(112 57 177)', 
                                    padding: '6px 12px', 
                                    borderRadius: '6px',
                                    marginRight: '10px',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <ConfirmationNumberIcon style={{ color: 'white', fontSize: '18px', marginRight: '6px' }} />
                                </Box>
                                <Typography variant="body2" style={{ color: '#333', fontWeight: 500, fontSize: '14px' }}>
                                    Digital Ticketing Platform
                                </Typography>
                            </Box>
                            
                            <Typography variant="h2" className={classes.heading} style={{ 
                                color: 'rgb(112 57 177)', 
                                marginBottom: '10px', 
                                fontSize: isMobile ? '32px' : '48px', 
                                lineHeight: '1.2' 
                            }}>
                                Your Digital Ticket,
                            </Typography>
                            <Typography variant="h2" className={classes.heading} style={{ 
                                color: '#333', 
                                marginBottom: '20px', 
                                fontSize: isMobile ? '32px' : '48px', 
                                lineHeight: '1.2' 
                            }}>
                                One Scan Away
                            </Typography>
                            <Typography variant="body1" style={{ 
                                color: '#333', 
                                marginBottom: '30px', 
                                lineHeight: '1.6', 
                                fontSize: isMobile ? '14px' : '16px' 
                            }}>
                                Book tickets for parks, events, appointments, and more. Get your QR code instantly and skip the queues. Fast, secure, and contactless entry.
                            </Typography>
                            
                            {/* Search Bar */}
                            <Box style={{ position: 'relative',  maxWidth: '600px' }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Search for parks, events, concerts..."
                                    value={searchQuery}
                                    onChange={(e) => handleSearch(e.target.value)}
                                    onFocus={() => setShowFilters(true)}
                                    className={classes.searchBar}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start" style={{ marginLeft: '12px' }}>
                                                <SearchIcon style={{ color: 'rgb(112, 57, 177)', fontSize: '24px' }} />
                                            </InputAdornment>
                                        ),
                                        style: {
                                            fontSize: '16px',
                                            height: '56px',
                                            paddingLeft: '8px'
                                        }
                                    }}
                                    inputProps={{
                                        style: {
                                            padding: '16px 20px 16px 8px',
                                            fontSize: '16px',
                                            color: '#333'
                                        }
                                    }}
                                />
                                {showSearchResults && searchResults.length > 0 && (
                                    <Box className={classes.searchResults}>
                                        {searchResults.map((result, index) => (
                                            <Box
                                                key={index}
                                                className={classes.searchResultItem}
                                                onClick={() => handleSearchResultClick(result)}
                                                style={{
                                                    backgroundColor: selectedSearchResult && selectedSearchResult.id === result.id ? '#E3F2FD' : 'transparent'
                                                }}
                                            >
                                                <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: 'rgb(111 57 176)', marginBottom: '4px' }}>
                                                    {result.type}
                                                </Typography>
                                                <Typography variant="body2" style={{ color: '#666' }}>
                                                    {result.name}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                )}
                            </Box>
                            
                            {/* Category Filter Buttons */}
                            {showFilters && (
                                <Box style={{ 
                                    position: 'relative',
                                    maxWidth: '600px',
                                    marginBottom: '30px',
                                    animation: 'fadeInUp 0.3s ease-in'
                                }}>
                                    <Box style={{ 
                                        display: 'flex', 
                                        gap: '12px', 
                                        overflowX: 'auto',
                                        overflowY: 'hidden',
                                        paddingBottom: '8px',
                                        scrollBehavior: 'smooth',
                                        scrollbarWidth: 'none',
                                        msOverflowStyle: 'none'
                                    }}
                                    className={classes.horizontalScroll}
                                    >
                                        {[
                                            { type: 'park', label: 'Parks', count: parkList?.length || 0 },
                                            { type: 'event', label: 'Events', count: eventList?.length || 0 },
                                            { type: 'doctor', label: 'Doctors', count: clinicList?.length || 0 },
                                            { type: 'loan', label: 'Bank Tokens', count: branchList?.length || 0 },
                                            { type: 'exbhition', label: 'Exhibitions', count: exbhitionList?.length || 0 }
                                        ].map((filter) => {
                                            const isSelected = selectedFilter === filter.type;
                                            return (
                                                <Button
                                                    key={filter.type}
                                                    variant="outlined"
                                                    onClick={() => {
                                                        setSelectedFilter(isSelected ? null : filter.type);
                                                    }}
                                                    style={{
                                                        backgroundColor: isSelected ? 'transparent' : 'white',
                                                        color: isSelected ? 'rgb(112, 57, 177)' : '#333',
                                                        border: `2px solid ${isSelected ? 'rgb(112, 57, 177)' : '#e0e0e0'}`,
                                                        borderRadius: '25px',
                                                        padding: '8px 20px',
                                                        textTransform: 'none',
                                                        fontSize: '14px',
                                                        fontWeight: isSelected ? 600 : 500,
                                                        transition: 'all 0.3s ease',
                                                        whiteSpace: 'nowrap',
                                                        minWidth: 'auto',
                                                        flexShrink: 0,
                                                        boxShadow: isSelected ? '0 2px 8px rgba(112, 57, 177, 0.2)' : 'none'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (!isSelected) {
                                                            e.currentTarget.style.borderColor = 'rgb(112, 57, 177)';
                                                            e.currentTarget.style.color = 'rgb(112, 57, 177)';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (!isSelected) {
                                                            e.currentTarget.style.borderColor = '#e0e0e0';
                                                            e.currentTarget.style.color = '#333';
                                                        }
                                                    }}
                                                >
                                                    {filter.label} ({filter.count})
                                                </Button>
                                            );
                                        })}
                                        {/* Arrow indicator */}
                                        <Box style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            paddingLeft: '8px',
                                            flexShrink: 0,
                                            color: '#999'
                                        }}>
                                            <ArrowForwardIcon style={{ fontSize: '20px' }} />
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                            
                            {/* Filtered Items Display */}
                            {selectedFilter && (
                                <Box style={{ 
                                    
                                    marginBottom: '30px',
                                    maxWidth: '600px',
                                    animation: 'fadeInUp 0.3s ease-in'
                                }}>
                                    <Typography variant="h6" style={{ 
                                        marginBottom: '20px', 
                                        color: '#666',
                                        fontWeight: 600,
                                        fontSize: '14px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '1px'
                                    }}>
                                        {selectedFilter === 'park' && `PARKS (${parkList?.length || 0})`}
                                        {selectedFilter === 'event' && `EVENTS (${eventList?.length || 0})`}
                                        {selectedFilter === 'doctor' && `DOCTORS (${clinicList?.length || 0})`}
                                        {selectedFilter === 'loan' && `BANK TOKENS (${branchList?.length || 0})`}
                                        {selectedFilter === 'exbhition' && `EXHIBITIONS (${exbhitionList?.length || 0})`}
                                    </Typography>
                                    
                                    <Box style={{
                                        backgroundColor: 'white',
                                        borderRadius: '8px',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                        padding: '8px 0',
                                        maxHeight: '400px',
                                        overflowY: 'auto'
                                    }}>
                                        {selectedFilter === 'park' && parkList?.map((park) => (
                                            <Box
                                                key={park._id}
                                                onClick={() => {
                                                    props.history.push(`/ticketbooking/${park._id}/${park.parkName?.toLowerCase() || 'park'}`);
                                                }}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '12px 20px',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #f0f0f0',
                                                    transition: 'background-color 0.2s'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = '#f5f5f5';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'transparent';
                                                }}
                                            >
                                                <Typography variant="body1" style={{ 
                                                    color: '#333',
                                                    fontSize: '15px',
                                                    fontWeight: 400
                                                }}>
                                                    {park.parkName}
                                                </Typography>
                                                <LocalMoviesIcon style={{ color: '#999', fontSize: '20px' }} />
                                            </Box>
                                        ))}
                                        
                                        {selectedFilter === 'event' && eventList?.map((event) => (
                                            <Box
                                                key={event._id}
                                                onClick={() => {
                                                    props.history.push(`/event/${event._id}`);
                                                }}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '12px 20px',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #f0f0f0',
                                                    transition: 'background-color 0.2s'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = '#f5f5f5';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'transparent';
                                                }}
                                            >
                                                <Typography variant="body1" style={{ 
                                                    color: '#333',
                                                    fontSize: '15px',
                                                    fontWeight: 400
                                                }}>
                                                    {event.eventName}
                                                </Typography>
                                                <EventIcon style={{ color: '#999', fontSize: '20px' }} />
                                            </Box>
                                        ))}
                                        
                                        {selectedFilter === 'doctor' && clinicList?.map((clinic) => (
                                            <Box
                                                key={clinic._id}
                                                onClick={() => {
                                                    props.history.push(`/doctorbooking/${clinic._id}`);
                                                }}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '12px 20px',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #f0f0f0',
                                                    transition: 'background-color 0.2s'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = '#f5f5f5';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'transparent';
                                                }}
                                            >
                                                <Typography variant="body1" style={{ 
                                                    color: '#333',
                                                    fontSize: '15px',
                                                    fontWeight: 400
                                                }}>
                                                    {clinic.clinicName}
                                                </Typography>
                                                <LocalHospitalIcon style={{ color: '#999', fontSize: '20px' }} />
                                            </Box>
                                        ))}
                                        
                                        {selectedFilter === 'loan' && branchList?.map((branch) => (
                                            <Box
                                                key={branch._id}
                                                onClick={() => {
                                                    props.history.push(`/loanbooking/${branch._id}`);
                                                }}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '12px 20px',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #f0f0f0',
                                                    transition: 'background-color 0.2s'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = '#f5f5f5';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'transparent';
                                                }}
                                            >
                                                <Typography variant="body1" style={{ 
                                                    color: '#333',
                                                    fontSize: '15px',
                                                    fontWeight: 400
                                                }}>
                                                    {branch.branchName}
                                                </Typography>
                                                <AccountBalanceIcon style={{ color: '#999', fontSize: '20px' }} />
                                            </Box>
                                        ))}
                                        
                                        {selectedFilter === 'exbhition' && exbhitionList?.map((exbhition) => (
                                            <Box
                                                key={exbhition._id}
                                                onClick={() => {
                                                    props.history.push(`/exbhitionbooking/${exbhition._id}`);
                                                }}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '12px 20px',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #f0f0f0',
                                                    transition: 'background-color 0.2s'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = '#f5f5f5';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'transparent';
                                                }}
                                            >
                                                <Typography variant="body1" style={{ 
                                                    color: '#333',
                                                    fontSize: '15px',
                                                    fontWeight: 400
                                                }}>
                                                    {exbhition.organizationName}
                                                </Typography>
                                                <ArtTrackIcon style={{ color: '#999', fontSize: '20px' }} />
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            )}
                            
                            {/* Book Tickets Button */}
                            <Button 
                                onClick={handleBuyTicket} 
                                endIcon={<ArrowForwardIcon style={{ fontSize: '20px' }} />} 
                                disabled={!selectedSearchResult}
                                onMouseEnter={(e) => {
                                    if (!selectedSearchResult) return;
                                    e.currentTarget.style.backgroundColor = 'rgb(112 57 176)';
                                    e.currentTarget.style.boxShadow = '0 6px 16px rgba(112, 57, 177, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    if (!selectedSearchResult) return;
                                    e.currentTarget.style.backgroundColor = 'rgb(112, 57, 177)';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(112, 57, 177, 0.3)';
                                }}
                                style={{ 
                                    backgroundColor: 'rgb(112, 57, 177)',
                                    color: 'white',
                                    padding: '16px 40px',
                                    borderRadius: '50px',
                                    textTransform: 'none',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    fontFamily: '"DM Sans", sans-serif',
                                    marginBottom: '30px',
                                    boxShadow: '0 4px 12px rgba(112, 57, 177, 0.3)',
                                    transition: 'all 0.3s ease',
                                    minWidth: '200px',
                                    height: '56px'
                                }}
                            >
                                Book Tickets
                            </Button>
                            
                            {/* Statistics */}
                            <Box style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
                                <CropFreeIcon style={{ color: '#f44336', fontSize: '24px' }} />
                                <Box>
                                    <Typography variant="h6" style={{ fontWeight: 'bold', color: '#333', fontSize: '18px', lineHeight: '1' }}>
                                        1M+
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#666', fontSize: '14px' }}>
                                        Tickets processed
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        
                        {/* Right Section - Business Owners */}
                        <Grid item xs={12} md={6} style={{ 
                            display: 'flex', 
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: isMobile ? '20px 16px' : '40px'
                        }}>
                            <Box style={{
                                background: 'linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 50%, #ffffff 100%)',
                                borderRadius: '16px',
                                padding: isMobile ? '30px 20px' : '40px',
                                boxShadow: '0 10px 40px rgba(112, 57, 177, 0.15)',
                                width: '100%',
                                maxWidth: '600px',
                                position: 'relative',
                                overflow: 'hidden',
                                border: '1px solid rgba(112, 57, 177, 0.1)'
                            }}>
                                {/* Decorative background pattern */}
                                <Box style={{
                                    position: 'absolute',
                                    top: '-50%',
                                    right: '-20%',
                                    width: '300px',
                                    height: '300px',
                                    borderRadius: '50%',
                                    background: 'radial-gradient(circle, rgba(112, 57, 177, 0.08) 0%, transparent 70%)',
                                    zIndex: 0
                                }}></Box>
                                <Box style={{
                                    position: 'absolute',
                                    bottom: '-30%',
                                    left: '-15%',
                                    width: '250px',
                                    height: '250px',
                                    borderRadius: '50%',
                                    background: 'radial-gradient(circle, rgba(25, 118, 210, 0.06) 0%, transparent 70%)',
                                    zIndex: 0
                                }}></Box>
                                <Box style={{ position: 'relative', zIndex: 1 }}>
                                {/* For Business Owners Tag */}
                                {/* <Box style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                                    <SendIcon style={{ color: '#f44336', fontSize: '20px', marginRight: '8px' }} />
                                    <Typography variant="body2" style={{ color: '#333', fontWeight: 500, fontSize: '14px' }}>
                                        For Business Owners
                                    </Typography>
                                </Box> */}
                                
                                <Typography variant="h2" style={{ 
                                    color: 'rgb(112, 57, 177)', 
                                    fontFamily: '"DM Sans", sans-serif',
                                fontWeight: 'bold', 
                                    marginBottom: '10px', 
                                    fontSize: isMobile ? '28px' : '33px', 
                                    lineHeight: '1.2' 
                                }}>
                                    Register Your Business Profile
                                </Typography>
                                <br/>
                                {/* <Typography variant="h2" style={{ 
                                    color: 'rgb(112, 57, 177)', 
                                    fontFamily: '"DM Sans", sans-serif',
                                fontWeight: 'bold', 
                                    marginBottom: '20px', 
                                    fontSize: isMobile ? '28px' : '40px', 
                                    lineHeight: '1.2' 
                                }}>
                                    Business Profile
                                </Typography> */}
                                
                                <Typography variant="body1" style={{ 
                                    color: '#333', 
                                    marginBottom: '30px', 
                                    lineHeight: '1.6', 
                                    fontSize: isMobile ? '14px' : '16px' ,
                                    textAlign: 'justify',   
                                }}>
                                    Join our ticketing platform and start selling tickets effortlessly. Whether you organize events, concerts, workshops, or exhibitions, our secure and easy registration process helps you set up your business profile in minutes. Once registered, you can list events, manage ticket sales, track real-time analytics, and streamline entry with QR-based validation.
                                </Typography>
                                
                                {/* Feature Icons Grid */}
                                <Grid container spacing={2} style={{ marginBottom: '30px' }}>
                                    <Grid item xs={3}>
                                        <Box style={{ 
                                            textAlign: 'center', 
                                            display: 'flex', 
                                            flexDirection: 'column', 
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: '100%'
                                        }}>
                                            <FlashOnIcon style={{ fontSize: '32px', color: '#333', marginBottom: '8px' }} />
                                            <Typography variant="body2" style={{ 
                                                color: '#333', 
                                                fontSize: '14px', 
                                                fontWeight: 500,
                                                textAlign: 'center',
                                                lineHeight: '1.4'
                                            }}>
                                                Quick Setup
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Box style={{ 
                                            textAlign: 'center', 
                                            display: 'flex', 
                                            flexDirection: 'column', 
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: '100%'
                                        }}>
                                            <AssessmentIcon style={{ fontSize: '32px', color: '#333', marginBottom: '8px' }} />
                                            <Typography variant="body2" style={{ 
                                                color: '#333', 
                                                fontSize: '14px', 
                                                fontWeight: 500,
                                                textAlign: 'center',
                                                lineHeight: '1.4'
                                            }}>
                                                Real-time Analytics
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Box style={{ 
                                            textAlign: 'center', 
                                            display: 'flex', 
                                            flexDirection: 'column', 
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: '100%'
                                        }}>
                                            <LockIcon style={{ fontSize: '32px', color: '#333', marginBottom: '8px' }} />
                                            <Typography variant="body2" style={{ 
                                                color: '#333', 
                                                fontSize: '14px', 
                                                fontWeight: 500,
                                                textAlign: 'center',
                                                lineHeight: '1.4'
                                            }}>
                                                Secure Payments
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Box style={{ 
                                            textAlign: 'center', 
                                            display: 'flex', 
                                            flexDirection: 'column', 
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: '100%'
                                        }}>
                                            <CropFreeIcon style={{ fontSize: '32px', color: '#333', marginBottom: '8px' }} />
                                            <Typography variant="body2" style={{ 
                                                color: '#333', 
                                                fontSize: '14px', 
                                                fontWeight: 500,
                                                textAlign: 'center',
                                                lineHeight: '1.4'
                                            }}>
                                                QR Validation
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                                
                                {/* Register Now Button */}
                                <Button 
                                    onClick={handleChange} 
                                    endIcon={<ArrowForwardIcon />} 
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = 'rgb(112 57 176)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '#rgb(111 57 176)';
                                    }}
                                    style={{ 
                                        backgroundColor: 'rgb(112 57 177)',
                                        color: 'white',
                                        padding: '14px 32px',
                                        borderRadius: '44px',
                                        textTransform: 'none',
                                        fontSize: '16px',
                                        fontWeight: 600,
                                        marginBottom: '20px',
                                        width: '100%',
                                        boxShadow: '0 4px 12px rgba(156, 39, 176, 0.3)',
                                        transition: 'background-color 0.3s ease'
                                    }}
                                >
                                    Register Now
                                </Button>
                                
                                {/* Benefit Statement */}
                                <Typography variant="body2" style={{ 
                                    color: '#666', 
                                    fontSize: '14px', 
                                    textAlign: 'center',
                                    lineHeight: '1.5'
                                }}>
                                    Grow your audience, simplify operations, and boost your event revenue.
                                </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            {/* Information Strip */}
            <Container style={{ padding: isMobile ? '20px 16px' : '30px 0' }}>
                <Box
                    onClick={() => {
                        window.open('about:blank', '_blank');
                    }}
                    style={{
                        backgroundColor: '#0D3B66',
                        borderRadius: '12px',
                        padding: isMobile ? '20px' : '30px 40px',
                        textAlign: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 12px rgba(13, 59, 102, 0.2)',
                        maxWidth: '1200px',
                        margin: '0 auto'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 6px 16px rgba(13, 59, 102, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(13, 59, 102, 0.2)';
                    }}
                >
                    <Typography
                        variant="h6"
                        style={{
                            color: 'white',
                            fontSize: isMobile ? '20px' : '28px',
                            fontWeight: 500,
                            lineHeight: '1.6',
                            fontFamily: '"DM Sans", sans-serif'
                        }}
                    >
                        Explore our{' '}
                        <span style={{ 
                            color: '#FFD700', 
                            fontWeight: 'bold',
                            textShadow: '0 1px 2px rgba(0,0,0,0.2)',
                            fontSize: isMobile ? '22px' : '30px'
                        }}>
                            "Zero pilferage ticketing"
                        </span>
                        {' '}application. GPRS enabled POS machines with dashboard and QR ticketing.
                    </Typography>
                </Box>
            </Container>

            {/* Latest Events Section */}
            {eventList && eventList.length > 0 && (
                <Container style={{ padding: isMobile ? '40px 16px' : '60px 0', backgroundColor: '#f8f9fa' }}>
                    <Typography variant="h3" className={classes.heading} align="center" style={{ 
                        color: 'rgb(112, 57, 177)', 
                        marginBottom: '10px',
                        fontSize: isMobile ? '24px' : '32px'
                    }}>
                        Latest Events
                    </Typography>
                    <Typography variant="h6" align="center" style={{ 
                        color: '#666', 
                        marginBottom: isMobile ? '30px' : '40px',
                        fontSize: isMobile ? '14px' : '16px'
                    }}>
                        Discover exciting events happening near you
                    </Typography>
                    <Grid container spacing={isMobile ? 2 : 3}>
                        {eventList.slice(0, 4).map((event) => (
                            <Grid item xs={12} sm={6} md={3} key={event._id}>
                                <Card 
                                    style={{ 
                                        height: '100%',
                                        borderRadius: '16px',
                                        overflow: 'hidden',
                                        cursor: 'pointer',
                                        transition: 'transform 0.3s, box-shadow 0.3s',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                                    }}
                                    onClick={() => {
                                        props.history.push(`/event/${event._id}`);
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-8px)';
                                        e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        style={{ 
                                            height: '200px',
                                            objectFit: 'cover',
                                            width: '100%'
                                        }}
                                        image={event.eventImage || 'https://via.placeholder.com/400x200/7039b1/ffffff?text=Event'}
                                        alt={event.eventName}
                                    />
                                    <CardContent style={{ padding: '20px' }}>
                                        <Typography 
                                            variant="h6" 
                                            className={classes.heading}
                                            style={{ 
                                                marginBottom: '8px',
                                                fontSize: '18px',
                                                color: '#333',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical'
                                            }}
                                        >
                                            {event.eventName}
                                        </Typography>
                                        {event.eventDescription && (
                                            <Typography 
                                                variant="body2" 
                                                style={{ 
                                                    color: '#666',
                                                    fontSize: '14px',
                                                    marginBottom: '12px',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: 'vertical',
                                                    lineHeight: '1.5'
                                                }}
                                            >
                                                {event.eventDescription}
                                            </Typography>
                                        )}
                                        {event.eventDate && (
                                            <Typography 
                                                variant="caption" 
                                                style={{ 
                                                    color: 'rgb(112, 57, 177)',
                                                    fontSize: '12px',
                                                    fontWeight: 600,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '4px'
                                                }}
                                            >
                                                <EventIcon style={{ fontSize: '16px' }} />
                                                {new Date(event.eventDate).toLocaleDateString('en-US', { 
                                                    year: 'numeric', 
                                                    month: 'short', 
                                                    day: 'numeric' 
                                                })}
                                            </Typography>
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                    {eventList.length > 4 && (
                        <Box style={{ textAlign: 'center', marginTop: '30px' }}>
                            <Button
                                onClick={() => props.history.push('/events')}
                                style={{
                                    backgroundColor: 'rgb(112, 57, 177)',
                                    color: 'white',
                                    padding: '12px 32px',
                                    borderRadius: '25px',
                                    textTransform: 'none',
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    fontFamily: '"DM Sans", sans-serif'
                                }}
                            >
                                View All Events
                            </Button>
                        </Box>
                    )}
                </Container>
            )}

            {/* Book Anything, Scan & Enter Section with Parallax */}
            <Box
                className="parallax-section"
                id="services"
                style={{
                    backgroundImage: 'linear-gradient(rgba(13, 59, 102, 0.7), rgba(13, 59, 102, 0.7)), url(https://images.unsplash.com/photo-1511578314322-379afb476865?w=1920&h=1080&fit=crop&auto=format)',
                    minHeight: 'auto',
                    padding: isMobile ? '60px 0' : '100px 0'
                }}
            >
                <div className="parallax-overlay" style={{ background: 'linear-gradient(135deg, rgba(112, 57, 177, 0.75) 0%, rgba(13, 59, 102, 0.75) 100%)' }}></div>
                <div className="parallax-content" style={{ width: '100%' }}>
                    <Container>
                        <Typography variant="h3" className={classes.heading} align="center" style={{ 
                            color: 'white', 
                            marginBottom: '15px',
                            fontSize: isMobile ? '24px' : '36px',
                            textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                        }}>
                            Buy, Scan & Enter
                        </Typography>
                        <Typography variant="h6" align="center" style={{ 
                            color: 'rgba(255,255,255,0.95)', 
                            marginBottom: isMobile ? '30px' : '50px',
                            fontSize: isMobile ? '14px' : '18px',
                            textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                            padding: isMobile ? '0 16px' : '0'
                        }}>
                            One platform for all your ticketing needs. Fast booking, instant QR codes, and hassle-free entry.
                        </Typography>
                        <Grid container spacing={4}>
                            <Grid item xs={12} sm={6} md={3}>
                                <Card className={classes.serviceCard} style={{ animationDelay: '0.1s', backgroundColor: 'rgba(255, 255, 255, 0.98)', boxShadow: '0 8px 24px rgba(0,0,0,0.25)' }}>
                            <Box style={{ overflow: 'hidden' }}>
                                <CardMedia
                                    component="img"
                                    className={classes.serviceCardMedia}
                                    image={parkImage}
                                    alt="Park Tickets"
                                />
                            </Box>
                            <CardContent className={classes.serviceCardContent}>
                                <Typography variant="h6" className={classes.serviceCardTitle}>
                                    Park Tickets
                                </Typography>
                                <Typography variant="body2" className={classes.serviceCardDescription}>
                                    Skip the ticket counter at amusement parks, theme parks, and recreational areas. Get instant entry with your QR code.
                                </Typography>
                                {parkId && parkList.find(p => p._id === parkId) && (
                                    <Box style={{ 
                                        marginBottom: '15px', 
                                        padding: isMobile ? '12px' : '15px', 
                                        backgroundColor: '#1976d2', 
                                        borderRadius: '20px', 
                                        textAlign: 'center',
                                        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
                                    }}>
                                        <Typography variant="h6" style={{ 
                                            fontFamily: '"DM Sans", sans-serif',
                                fontWeight: 'bold', 
                                            color: 'white',
                                            margin: 0,
                                            fontSize: isMobile ? '16px' : '18px'
                                        }}>
                                            {parkList.find(p => p._id === parkId).parkName}
                                        </Typography>
                                    </Box>
                                )}
                                <Box style={{ marginBottom: '15px' }}>
                                    <Grid item xs={12}>
                                        <div style={{ width: '100%', maxWidth: '270px', margin: '0 auto' }}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <InputLabel id="park-select-label-service">Select Park ({parkList && parkList.length ? parkList.length : 0})</InputLabel>
                                                <Select
                                                    labelId="park-select-label-service"
                                                    id="park-select-service"
                                                    name="parkId"
                                                    label={`Select Park (${parkList && parkList.length ? parkList.length : 0})`}
                                                    value={parkId || ""}
                                                    onChange={e => {
                                                        const selectedParkId = e.target.value;
                                                        if (selectedParkId && selectedParkId !== "") {
                                                            const foundPark = parkList.find(p => p._id === selectedParkId);
                                                            if (foundPark) {
                                                                setParkName(foundPark.parkName ? foundPark.parkName.toLowerCase() : '');
                                                                setParkId(foundPark._id);
                                                                // Redirect immediately
                                                                props.history.push(`ticketbooking/${foundPark._id}/${foundPark.parkName.toLowerCase()}`);
                                                            }
                                                        } else {
                                                            setParkName('');
                                                            setParkId('');
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {parkList && Array.isArray(parkList) && parkList.length > 0 ? (
                                                        parkList.map((parkDet) => (
                                                            <MenuItem key={parkDet._id} value={parkDet._id}>
                                                                {parkDet.parkName || 'Unnamed Park'}
                                                            </MenuItem>
                                                        ))
                                                    ) : (
                                                        <MenuItem disabled>No parks available</MenuItem>
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Box>
                                <Button 
                                    variant="contained" 
                                    fullWidth 
                                    onClick={handleRedirect}
                                    className={classes.serviceCardButton}
                                >
                                    Book Your Ticket
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Card className={classes.serviceCard} style={{ animationDelay: '0.2s', backgroundColor: 'rgba(255, 255, 255, 0.98)', boxShadow: '0 8px 24px rgba(0,0,0,0.25)' }}>
                            <Box style={{ overflow: 'hidden' }}>
                                <CardMedia
                                    component="img"
                                    className={classes.serviceCardMedia}
                                    image={bankImage}
                                    alt="Bank Tokens"
                                />
                            </Box>
                            <CardContent className={classes.serviceCardContent}>
                                <Typography variant="h6" className={classes.serviceCardTitle}>
                                    Bank Tokens
                                </Typography>
                                <Typography variant="body2" className={classes.serviceCardDescription}>
                                    Book your bank visit in advance. Get a virtual token and walk in at your scheduled time without waiting in queues.
                                </Typography>
                                {branchId && branchList.find(b => b._id === branchId) && (
                                    <Box style={{ 
                                        marginBottom: '15px', 
                                        padding: isMobile ? '12px' : '15px', 
                                        backgroundColor: '#1976d2', 
                                        borderRadius: '20px', 
                                        textAlign: 'center',
                                        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
                                    }}>
                                        <Typography variant="h6" style={{ 
                                            fontFamily: '"DM Sans", sans-serif',
                                fontWeight: 'bold', 
                                            color: 'white',
                                            margin: 0,
                                            fontSize: isMobile ? '16px' : '18px'
                                        }}>
                                            {branchList.find(b => b._id === branchId).branchName}
                                        </Typography>
                                    </Box>
                                )}
                                <Box style={{ marginBottom: '15px' }}>
                                    <Grid item xs={12}>
                                        <div style={{ width: '100%', maxWidth: '270px', margin: '0 auto' }}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <InputLabel id="branch-select-label-service">Select Bank Branch ({branchList && branchList.length ? branchList.length : 0})</InputLabel>
                                                <Select
                                                    labelId="branch-select-label-service"
                                                    id="branch-select-service"
                                                    name="branchId"
                                                    label={`Select Bank Branch (${branchList && branchList.length ? branchList.length : 0})`}
                                                    value={branchId || ""}
                                                    onChange={e => {
                                                        const selectedBranchId = e.target.value;
                                                        if (selectedBranchId && selectedBranchId !== "") {
                                                            const foundBranch = branchList.find(b => b._id === selectedBranchId);
                                                            if (foundBranch) {
                                                                setBranchName(foundBranch.branchName ? foundBranch.branchName.toLowerCase() : '');
                                                                setBranchId(foundBranch._id);
                                                                // Redirect immediately
                                                                props.history.push(`loanbooking/${foundBranch._id}/${foundBranch.branchName.toLowerCase()}`);
                                                            }
                                                        } else {
                                                            setBranchName('');
                                                            setBranchId('');
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {branchList && Array.isArray(branchList) && branchList.length > 0 ? (
                                                        branchList.map((branchDet) => (
                                                            <MenuItem key={branchDet._id} value={branchDet._id}>
                                                                {branchDet.branchName || 'Unnamed Branch'}
                                                            </MenuItem>
                                                        ))
                                                    ) : (
                                                        <MenuItem disabled>No branches available</MenuItem>
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Box>
                                <Button 
                                    variant="contained" 
                                    fullWidth 
                                    onClick={handleRedirectBranch}
                                    className={classes.serviceCardButton}
                                >
                                    Book Your Appointment
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Card className={classes.serviceCard} style={{ animationDelay: '0.3s', backgroundColor: 'rgba(255, 255, 255, 0.98)', boxShadow: '0 8px 24px rgba(0,0,0,0.25)' }}>
                            <Box style={{ overflow: 'hidden' }}>
                                <CardMedia
                                    component="img"
                                    className={classes.serviceCardMedia}
                                    image={doctorImage}
                                    alt="Doctor Appointments"
                                />
                            </Box>
                            <CardContent className={classes.serviceCardContent}>
                                <Typography variant="h6" className={classes.serviceCardTitle}>
                                    Doctor Appointments
                                </Typography>
                                <Typography variant="body2" className={classes.serviceCardDescription}>
                                    Schedule and manage your medical appointments. Check in seamlessly with your QR code at the clinic or hospital.
                                </Typography>
                                {clinicId && clinicList.find(c => c._id === clinicId) && (
                                    <Box style={{ 
                                        marginBottom: '15px', 
                                        padding: isMobile ? '12px' : '15px', 
                                        backgroundColor: '#1976d2', 
                                        borderRadius: '20px', 
                                        textAlign: 'center',
                                        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
                                    }}>
                                        <Typography variant="h6" style={{ 
                                            fontFamily: '"DM Sans", sans-serif',
                                fontWeight: 'bold', 
                                            color: 'white',
                                            margin: 0,
                                            fontSize: isMobile ? '16px' : '18px'
                                        }}>
                                            {clinicList.find(c => c._id === clinicId).clinicName}
                                        </Typography>
                                    </Box>
                                )}
                                <Box style={{ marginBottom: '15px' }}>
                                    <Grid item xs={12}>
                                        <div style={{ width: '100%', maxWidth: '270px', margin: '0 auto' }}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <InputLabel id="clinic-select-label-service">Select Clinic ({clinicList && clinicList.length ? clinicList.length : 0})</InputLabel>
                                                <Select
                                                    labelId="clinic-select-label-service"
                                                    id="clinic-select-service"
                                                    name="clinicId"
                                                    label={`Select Clinic (${clinicList && clinicList.length ? clinicList.length : 0})`}
                                                    value={clinicId || ""}
                                                    onChange={e => {
                                                        const selectedClinicId = e.target.value;
                                                        if (selectedClinicId && selectedClinicId !== "") {
                                                            const foundClinic = clinicList.find(c => c._id === selectedClinicId);
                                                            if (foundClinic) {
                                                                setClinicName(foundClinic.clinicName ? foundClinic.clinicName.toLowerCase() : '');
                                                                setClinicId(foundClinic._id);
                                                                // Redirect immediately
                                                                props.history.push(`doctorbooking/${foundClinic._id}/${foundClinic.clinicName.toLowerCase()}`);
                                                            }
                                                        } else {
                                                            setClinicName('');
                                                            setClinicId('');
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {clinicList && Array.isArray(clinicList) && clinicList.length > 0 ? (
                                                        clinicList.map((clinicDet) => (
                                                            <MenuItem key={clinicDet._id} value={clinicDet._id}>
                                                                {clinicDet.clinicName || 'Unnamed Clinic'}
                                                            </MenuItem>
                                                        ))
                                                    ) : (
                                                        <MenuItem disabled>No clinics available</MenuItem>
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Box>
                                <Button 
                                    variant="contained" 
                                    fullWidth 
                                    onClick={handleRedirectDoctor}
                                    className={classes.serviceCardButton}
                                >
                                    Book Your Appointment
                                </Button>
                            </CardContent>
                        </Card>
                                </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Card className={classes.serviceCard} style={{ animationDelay: '0.4s', backgroundColor: 'rgba(255, 255, 255, 0.98)', boxShadow: '0 8px 24px rgba(0,0,0,0.25)' }}>
                            <Box style={{ overflow: 'hidden' }}>
                                <CardMedia
                                    component="img"
                                    className={classes.serviceCardMedia}
                                    image="https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=400&h=200&fit=crop&auto=format"
                                    alt="Event Tickets"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = "https://via.placeholder.com/400x200/1976d2/ffffff?text=Event+Tickets";
                                    }}
                                />
                            </Box>
                            <CardContent className={classes.serviceCardContent}>
                                <Typography variant="h6" className={classes.serviceCardTitle}>
                                    Event Tickets
                                </Typography>
                                <Typography variant="body2" className={classes.serviceCardDescription}>
                                    Concerts, festivals, conferences, and more. Secure your spot and breeze through entry with contactless QR scanning.
                                </Typography>
                                {(() => {
                                    const urlParams = new URLSearchParams(window.location.search);
                                    const eventIdFromUrl = urlParams.get('eventId') || window.location.pathname.split('/').pop();
                                    const selectedEvent = eventList.find(e => e._id === eventIdFromUrl);
                                    return selectedEvent ? (
                                        <Box style={{ 
                                            marginBottom: '15px', 
                                            padding: isMobile ? '12px' : '15px', 
                                            backgroundColor: '#1976d2', 
                                            borderRadius: '8px', 
                                            textAlign: 'center',
                                            boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
                                        }}>
                                            <Typography variant="h6" style={{ 
                                                fontFamily: '"DM Sans", sans-serif',
                                fontWeight: 'bold', 
                                                color: 'white',
                                                margin: 0,
                                                fontSize: isMobile ? '16px' : '18px'
                                            }}>
                                                {selectedEvent.eventName}
                                            </Typography>
                                        </Box>
                                    ) : null;
                                })()}
                                <Box style={{ marginBottom: '15px' }}>
                                    <Grid item xs={12}>
                                        <div style={{ width: '100%', maxWidth: '270px', margin: '0 auto' }}>
                                            <FormControl className={classes.formControl} fullWidth={true}>
                                                <InputLabel id="event-select-label-service">Select Event ({eventList && eventList.length ? eventList.length : 0})</InputLabel>
                                                <Select
                                                    labelId="event-select-label-service"
                                                    id="event-select-service"
                                                    name="eventId"
                                                    label={`Select Event (${eventList && eventList.length ? eventList.length : 0})`}
                                                    onChange={e => {
                                                        const selectedEventId = e.target.value;
                                                        if (selectedEventId && selectedEventId !== "") {
                                                            props.history.push(`/event/${selectedEventId}`);
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {eventList && Array.isArray(eventList) && eventList.length > 0 ? (
                                                        eventList.map((eventDet) => (
                                                            <MenuItem key={eventDet._id} value={eventDet._id}>
                                                                {eventDet.eventName || 'Unnamed Event'}
                                                            </MenuItem>
                                                        ))
                                                    ) : (
                                                        <MenuItem disabled>No events available</MenuItem>
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Box>
                                <Button 
                                    variant="contained" 
                                    fullWidth 
                                    onClick={handleEvents}
                                    className={classes.serviceCardButton}
                                >
                                    View All Events
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                    </Container>
                </div>
            </Box>
            
            {/* Halloween Banner Section */}
            {/* <section style={{ padding: '20px 0', backgroundColor: '#f8f9fa' }}>
                <Container>
                    <Box style={{ textAlign: 'center' }}>
                        <img 
                            src={halloween} 
                            alt="Halloween Special" 
                            style={{ 
                                width: '100%', 
                                maxWidth: '800px', 
                                height: 'auto',
                                borderRadius: '10px',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                            }} 
                        />
                    </Box>
                </Container>
            </section> */}
            
            {/* How It Works Section */}
            <Box style={{ backgroundColor: '#f5f5f5', padding: isMobile ? '40px 0' : '80px 0' }} id="how-it-works">
                <Container>
                    <Typography variant="h3" align="center" style={{ 
                        color: 'rgb(112 57 177)', 
                        fontWeight: 'bold', 
                        marginBottom: '15px',
                        fontSize: isMobile ? '24px' : '32px'
                    }}>
                        How It Works - Ticketing process
                    </Typography>
                    <Typography variant="h6" align="center" style={{ 
                        color: '#666', 
                        marginBottom: isMobile ? '30px' : '50px',
                        fontSize: isMobile ? '14px' : '16px',
                        padding: isMobile ? '0 16px' : '0'
                    }}>
                        Get your QR ticket in 4 simple steps. No printing required, no hassle.
                    </Typography>
                    <Grid container spacing={isMobile ? 2 : 4}>
                        {[
                            { number: 1, icon: <PhoneAndroidIcon style={{ width: '2em', height:"2em" }}/>, title: 'Choose & Book', desc: 'Select your service and complete your booking in seconds with our simple interface.' },
                            { number: 2, icon: <CreditCardIcon style={{ width: '2em', height:"2em" }}/>, title: 'Pay Securely', desc: 'Make a secure payment using your preferred method. All transactions are encrypted.' },
                            { number: 3, icon: <CropFreeIcon style={{ width: '2em', height:"2em" }}/>, title: 'Get Your QR Code', desc: 'Receive your unique QR ticket instantly via email and in your account dashboard.' },
                            { number: 4, icon: <CheckCircleIcon style={{ width: '2em', height:"2em" }}/>, title: 'Scan & Enter', desc: 'Show your QR code at the gate. One scan and you\'re in! The code expires after use.' }
                        ].map((step, index) => (
                            <Grid item xs={12} sm={6} md={3} key={index}>
                                <Box className={classes.stepCard}>
                                    <Box className={classes.stepNumber}>{step.number}</Box>
                                    <Box style={{ fontSize: isMobile ? '32px' : '40px', color: '#1976d2', marginBottom: '20px' }}>{step.icon}</Box>
                                    <Typography variant="h6" style={{ 
                                        fontFamily: '"DM Sans", sans-serif',
                                fontWeight: 'bold', 
                                        marginBottom: '10px',
                                        fontSize: isMobile ? '16px' : '18px'
                                    }}>{step.title}</Typography>
                                    <Typography variant="body2" style={{ 
                                        color: '#666',
                                        fontSize: isMobile ? '13px' : '14px'
                                    }}>{step.desc}</Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
            
            {/* One-Time Use Security Card - Outside Parallax */}
            <Container style={{ padding: isMobile ? '40px 16px' : '60px 0' }}>
                <Box style={{ 
                    backgroundColor: 'white', 
                    padding: isMobile ? '20px' : '30px', 
                    borderRadius: '12px', 
                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)' 
                }}>
                    <Box style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        marginBottom: '15px',
                        flexDirection: isMobile ? 'column' : 'row',
                        textAlign: isMobile ? 'center' : 'left'
                    }}>
                        <SecurityIcon style={{ 
                            color: '#1976d2', 
                            marginRight: isMobile ? '0' : '15px', 
                            marginBottom: isMobile ? '10px' : '0',
                            fontSize: isMobile ? '24px' : '30px' 
                        }} />
                        <Typography variant="h6" style={{ 
                            fontFamily: '"DM Sans", sans-serif',
                            fontWeight: 'bold',
                            fontSize: isMobile ? '16px' : '18px',
                            color: '#333'
                        }}>One-Time Use Security</Typography>
                    </Box>
                    <Typography variant="body2" style={{ 
                        color: '#666', 
                        lineHeight: '1.8',
                        fontSize: isMobile ? '13px' : '14px'
                    }}>
                        Each QR code is valid for a single entry only. Once scanned at the gate, it automatically becomes invalid to prevent unauthorized reuse. This ensures maximum security for both venues and ticket holders.
                    </Typography>
                </Box>
            </Container>

            {/* Parallax Section 3 - Features */}
            {/* <Box
                className="parallax-section"
                style={{
                    backgroundImage: 'linear-gradient(rgba(13, 59, 102, 0.6), rgba(13, 59, 102, 0.6)), url(https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1920&h=1080&fit=crop&auto=format)',
                    minHeight: isMobile ? '300px' : '450px'
                }}
            >
                <div className="parallax-overlay" style={{ background: 'linear-gradient(135deg, rgba(112, 57, 177, 0.8) 0%, rgba(25, 118, 210, 0.8) 100%)' }}></div>
                <div className="parallax-content">
                    <Container>
                        <Typography variant="h3" align="center" style={{ 
                            color: 'white', 
                            fontWeight: 'bold', 
                            marginBottom: '15px',
                            fontSize: isMobile ? '24px' : '36px',
                            textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                        }}>
                            Setup your ticketing instantly in 6 steps
                        </Typography>
                        <Typography variant="h6" align="center" style={{ 
                            color: 'rgba(255,255,255,0.95)', 
                            marginBottom: '30px',
                            fontSize: isMobile ? '16px' : '20px',
                            textShadow: '1px 1px 2px rgba(0,0,0,0.3)'
                        }}>
                            Fast, secure, and reliable ticketing platform trusted by thousands of users.
                        </Typography>
                    </Container>
                </div>
            </Box> */}

            {/* Setup Your Ticketing Section */}
            <Container style={{ padding: isMobile ? '40px 16px' : '80px 0' }} id="features">
                <Typography variant="h3" align="center" style={{ 
                    color: '#1976d2', 
                    fontWeight: 'bold', 
                    marginBottom: '15px',
                    fontSize: isMobile ? '24px' : '32px'
                }}>
                    Setup your ticketing instantly in 6 steps
                </Typography>
                <Typography variant="h6" align="center" style={{ 
                    color: '#666', 
                    marginBottom: isMobile ? '30px' : '50px',
                    fontSize: isMobile ? '14px' : '16px',
                    padding: isMobile ? '0 16px' : '0'
                }}>
                    Fast, secure, and reliable ticketing platform trusted by thousands of users.
                </Typography>
                <Grid container spacing={isMobile ? 2 : 4}>
                    {[
                        { icon: <FlashOnIcon style={{ width: '2em', height:"2em" }} />, title: 'Register profile', desc: 'Setup your ticketing in minutes and start selling instantly.' },
                        { icon: <AddCircleIcon style={{ width: '2em', height:"2em" }} />, title: 'Add Event/Park/Exhibition/Appointments', desc: 'Create, launch, and manage your tickets effortlessly—all in one place.' },
                        { icon: <AccessTimeIcon style={{ width: '2em', height:"2em" }} />, title: 'Payment Gateway', desc: 'Go live with your event in just a few clicks and start collecting payments instantly.' },
                        { icon: <PhoneAndroidIcon style={{ width: '2em', height:"2em" }} />, title: 'Download QR code and online link', desc: 'Streamline your entire ticketing process with fast QR-based setup.' },
                        { icon: <LockIcon style={{ width: '2em', height:"2em" }}/>, title: 'Start selling tickets...', desc: 'From registration to selling—everything happens seamlessly and instantly.' },
                        { icon: <HeadsetMicIcon style={{ width: '2em', height:"2em" }}/>, title: '24/7 Support', desc: 'Our customer support team is always ready to help you with any issues.' }
                    ].map((feature, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Box className={classes.featureCard}>
                                <Box style={{ fontSize: isMobile ? '36px' : '50px', color: '#1976d2', marginBottom: '20px' }}>{feature.icon}</Box>
                                <Typography variant="h6" style={{ 
                                    fontFamily: '"DM Sans", sans-serif',
                                fontWeight: 'bold', 
                                    marginBottom: '10px',
                                    fontSize: isMobile ? '16px' : '18px'
                                }}>{feature.title}</Typography>
                                <Typography variant="body2" style={{ 
                                    color: '#666',
                                    fontSize: isMobile ? '13px' : '14px'
                                }}>{feature.desc}</Typography>
            </Box>
          </Grid>
                    ))}
                </Grid>
            </Container>

            {/* Ready to Skip the Queue CTA Section */}
            {/* <Box className={classes.ctaSection} style={{ padding: isMobile ? '40px 0' : '80px 0' }}>
                <Container>
                    <Box style={{ textAlign: 'center', marginBottom: '20px' }}>
                        <Chip 
                            label="Join thousands of happy users" 
                            style={{ 
                                backgroundColor: 'rgba(255,255,255,0.2)', 
                                color: 'white', 
                                marginBottom: '20px',
                                fontSize: isMobile ? '12px' : '14px'
                            }} 
                        />
              </Box>
                    <Typography variant="h3" align="center" style={{ 
                        color: 'white', 
                        fontWeight: 'bold', 
                        marginBottom: '20px',
                        fontSize: isMobile ? '24px' : '32px',
                        padding: isMobile ? '0 16px' : '0'
                    }}>
                        Ready to Skip the Queue?
              </Typography>
                    <Typography variant="h6" align="center" style={{ 
                        color: 'rgba(255,255,255,0.9)', 
                        marginBottom: '40px', 
                        maxWidth: '700px', 
                        margin: '0 auto 40px',
                        fontSize: isMobile ? '14px' : '16px',
                        padding: isMobile ? '0 16px' : '0'
                    }}>
                        Start booking smarter today. Get your tickets instantly and enjoy seamless entry with our secure QR code system.
              </Typography>
                    <Box style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        gap: isMobile ? '10px' : '20px', 
                        marginBottom: isMobile ? '40px' : '60px', 
                        flexWrap: 'wrap',
                        flexDirection: isMobile ? 'column' : 'row',
                        padding: isMobile ? '0 16px' : '0'
                    }}>
                        <Button 
                            className={classes.primaryBtn} 
                            onClick={handleChange} 
                            endIcon={<ArrowForwardIcon />} 
                            style={{ 
                                backgroundColor: 'white', 
                                color: '#1976d2',
                                width: isMobile ? '100%' : 'auto'
                            }}
                        >
                            Get Started Now
                        </Button>
                        <Button 
                            className={classes.secondaryBtn} 
                            onClick={handleEvents} 
                            style={{ 
                                backgroundColor: 'transparent', 
                                color: 'white', 
                                borderColor: 'white',
                                width: isMobile ? '100%' : 'auto'
                            }}
                        >
                            Learn More
                        </Button>
                    </Box>
                    <Grid container spacing={isMobile ? 2 : 4}>
                        {[
                            { number: '50K+', label: 'Tickets Booked' },
                            { number: '500+', label: 'Partner Venues' },
                            { number: '4.9★', label: 'User Rating' }
                        ].map((stat, index) => (
                            <Grid item xs={12} md={4} key={index}>
                                <Box className={classes.statCard}>
                                    <Typography variant="h3" style={{ 
                                        color: 'white', 
                                        fontFamily: '"DM Sans", sans-serif',
                                fontWeight: 'bold', 
                                        marginBottom: '10px',
                                        fontSize: isMobile ? '28px' : '32px'
                                    }}>{stat.number}</Typography>
                                    <Typography variant="h6" style={{ 
                                        color: 'rgba(255,255,255,0.9)',
                                        fontSize: isMobile ? '14px' : '16px'
                                    }}>{stat.label}</Typography>
            </Box>
          </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box> */}

            <ModernFooter
                history={props.history}
                isMobile={isMobile}
                onServicesClick={handleServicesClick}
                onHowItWorksClick={handleHowItWorksClick}
                onPrivacyPolicy={handlePrivacyPolicy}
                onTermsConditions={handleTermsConditions}
                onRefundPolicy={handleRefundPolicy}
            />

            {/* Old Sections */}
            <>
            {/* <section id="features" class="features section">
                <div class="container"> */}
                    {/* <div class="row">
                        <div class="col-12">
                            <div class="section-title" style={{padding:0}}>
                                <h3 class="wow zoomIn" data-wow-delay=".2s">Digitalization</h3>
                                <h2 class="wow fadeInUp" data-wow-delay=".4s">Your Experience Gets Better And Better Over Time.
                        </h2>
                                 <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#333' }}>
          Thanks to the UPI payments revolution in India, the widespread use of QR codes for
          transactions has become common knowledge. This serves as a strong foundation for the
          development of innovative QR code solutions. Our services cater to a wide range of needs,
          from entry tickets and applicant tokens to doctor appointments, diagnostic test registrations,
          parking facilities, and cloak rooms. We are constantly expanding into new verticals. Our
          solutions eliminate the need for cash handling in various sectors such as parks, museums, shows,
          events, cinemas, parking lots, and cloak rooms. We also offer cashless transaction options for
          finance companies to streamline the loan application process, as well as for doctor appointments
          both in-clinic and online. Our system is quick to set up and easy to use. Simply create a profile,
          add your business details, generate a QR code, poster generated, and start processing transactions
          seamlessly.
        </p>
                            </div>
                        </div>
                    </div> */}
                    {/* <div class="row"> */}
                        {/* <div class="col-lg-4 col-md-6 col-12">
                   
                    <div class="single-feature wow fadeInUp" data-wow-delay=".2s">
                        <i class="lni lni-cloud-upload"></i>
                        <h3>Introduction</h3>
                        <p>Sriqr.com makes it a simple, process of entry into parks, events, parking, Cloakrooms process, Diagnostic centre, gym management. Besides reports, Analytics, feedback and consultancy for upgrading services are also provided.</p>
                    </div>
                   
                </div> */}
                        {/* <div class="col-lg-6 col-md-6 col-12">

                            <div class="single-feature wow fadeInUp" data-wow-delay=".4s">


                                <i class="lni lni-lock"><CachedIcon /></i>
                                <h3>How it Works</h3>
                                <p>
                                Each client's business is assigned a unique QR code. When the customer/visitor scans the QR code, it opens a page related to client’s business. The customer/visitor then enters their details of services required, which are processed to calculate the amount to be paid. Once the client proceeds with the payment process and the payment is received, a QR code is generated containing the details of the services availed by the client. QR code generated is scanned by authorised person of client through a mobile app, which displays the services availed, business name, date and time. No cash handling by persons, money credited directly into business account of entity
     </p>
                            </div>

                        </div>
                        <div class="col-lg-6 col-md-6 col-12">

                            <div class="single-feature wow fadeInUp" data-wow-delay=".6s" style={{height:'446px'}}>
                                <i class="lni lni-reload"><PhonelinkLockIcon /></i>
                                <h3>Validation of QR codes reacheceived</h3>
                                <p>
                                    Android mobile app is provided to scan QR code received by customer/Visitor on successful payment.
                                    QR code received by client is scanned by authorised person of business entity to know services availed by client same is delivered. Once scanned QR code it becomes invalid. Simple process, any business can register online, Paytm team will reach and process merchant registration

                                </p>
                            </div>

                        </div>
                        <div class="col-lg-6 col-md-6 col-12">

                            <div class="single-feature wow fadeInUp" data-wow-delay=".2s">
                                <i class="lni lni-shield"><AcUnitIcon /></i>
                                <h3>Services </h3>
                                <p>All services availed, price paid by client stored in database for generation of MIS and analytics.
                                    “Get QR” option also in application in case QR not received by user after successful payment, user enters mobile number which entered while processing, if payment done successfully, QR will be downloaded with details.
                                </p>
                            </div>

                        </div> */}
                        {/* <div class="col-lg-4 col-md-6 col-12">
                  
                    <div class="single-feature wow fadeInUp" data-wow-delay=".4s">
                        <i class="lni lni-cog"></i>
                        <h3>Process</h3>
                        <p>Simple process, any business can register online, Paytm team will reach and process merchant registration.</p>
                    </div>
                   
                </div> */}
                        {/* <div class="col-lg-6 col-md-6 col-12">

                            <div class="single-feature wow fadeInUp" data-wow-delay=".6s" style={{height:"313px"}}>
                                <i class="lni lni-layers"><PaymentIcon /></i>
                                <h3>Payments </h3>
                                <p>
                                    All payments processed are transferred by Paytm, into business entity’s bank account next day. Paytm business app updates each transaction as it receives payment. Authorised Person can view each transaction, in case client not received QR code, it can be confirmed with this app for instant process of services availed by customer.
                                </p>
                            </div>

                        </div> */}
                    {/* </div>
                </div>
            </section> */}
            

        
            {/* <section class="our-achievement section">
                <div class="container">
                    <div class="row" >
                        <div class="col-lg-10 offset-lg-1 col-md-12 col-12">
                            <div class="title">
                                <h2>Digitalization</h2>
                                
                                <p>Simple process, any business can register online, Paytm team will reach and process merchant registration.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12  col-md-11 col-10">
                            <p style={{ color: "white", textAlign:'justify', fontSize:'medium'}}>

Thanks to the UPI payments revolution in India, the widespread use of QR codes for transactions has become common knowledge. This serves as a strong foundation for the development of innovative QR code solutions.
Our services cater to a wide range of needs, from entry tickets and applicant tokens to doctor appointments, diagnostic test registrations, parking facilities, and cloak rooms. We are constantly expanding into new verticals.
Our solutions eliminate the need for cash handling in various sectors such as parks, museums, shows, events, cinemas, parking lots, and cloak rooms.
We also offer cashless transaction options for finance companies to streamline the loan application process, as well as for doctor appointments both in-clinic and online.
Our system is quick to set up and easy to use.
Simply create a profile, add your business details, generate a QR code, poster generated, and start processing transactions seamlessly.
                            </p >
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-12">
                                    <div class="single-achievement wow fadeInUp" data-wow-delay=".2s">
                                        <h3 class="counter"><span id="secondo1" class="countup" cup-end="100">100</span>%</h3>
                                        <p>digital</p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-12">
                                    <div class="single-achievement wow fadeInUp" data-wow-delay=".4s">
                                        <h3 class="counter"><span id="secondo2" class="countup" cup-end="120">120</span>K</h3>
                                        <p>Happy Users</p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-12">
                                    <div class="single-achievement wow fadeInUp" data-wow-delay=".6s">
                                        <h3 class="counter"><span id="secondo3" class="countup" cup-end="125">100</span>%</h3>
                                        <p>secure</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* <section id="pricing" class="pricing-table section">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="section-title">
                                <h3 class="wow zoomIn" data-wow-delay=".2s">pricing</h3>
                                <h2 class="wow fadeInUp" data-wow-delay=".4s">Services</h2>
                                <p class="wow fadeInUp" data-wow-delay=".6s">There are many variations of passages of Lorem
                                    Ipsum available, but the majority have suffered alteration in some form.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-12">

                            <div class="single-table wow fadeInUp" data-wow-delay=".6s">

                                <div class="table-head">
                                    <h4 class="title" style={{ fontWeight: 'bold', color: '#000', marginBottom: '10px' }}>Park</h4>
                        <p>All the basics for starting a new business</p>
                        <div class="price">
                                <h2 class="amount">$12<span class="duration">/mo</span></h2>
                            </div>
                        <div class="table-content">
                                        <h4 class="middle-title" style={{ textAlign: 'center', color: '#000', fontWeight: 'bold', marginBottom: '10px', textTransform: 'uppercase' }}>ENTRY TICKETS</h4>
                                        <p style={{ textAlign: 'center', marginBottom: '20px' }}>Scan-Pay-Enter system for seamless access to parks, exhibitions, and events.</p>
                                    </div>
                                    <div class="hero-content">
                                    <Grid item xs={12}>
                                    <div style={{ width: '100%', maxWidth: '270px', margin: '0 auto' }}>
                                        <FormControl className={classes.formControl} fullWidth="true"
                                        >
                                            <InputLabel id="demo-simple-select-label">Select Park ({parkList.length})</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="parkId"
                                                label={`Select Park (${parkList.length})`}
                                              
                                                onChange={e => {
                                                    setParkName(e.target.value.parkName.toLowerCase());

                                                    setParkId(e.target.value._id)
                                                }}
                                            error={formik.touched.parkId && Boolean(formik.errors.parkId)}
                                            helperText={formik.touched.parkId && formik.errors.parkId}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>

                                                {parkList.map((parkDet) => (
                                                    <MenuItem key={parkDet._id} value={parkDet}>{parkDet.parkName}

                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Grid>
                                    <br></br>
                                    <div class="button wow fadeInLeft" data-wow-delay=".8s" style={{ textAlign: 'center' }}>

                                    <a href="javascript:void(0)" class="btn" onClick={handleRedirect} style={{backgroundColor:'rgb(112, 57, 177)'}}><i class="lni lni-apple"></i> Book Your Ticket</a>
                                    <a href="javascript:void(0)" class="btn btn-alt"><i class="lni lni-play-store"></i> Google
                                Play</a>
                                </div>
                                </div>
                                    <div class="button">
                                        <a href="javascript:void(0)" class="btn">Click Here</a>
                                    </div>
                                </div>


                            </div>
                        </div> 
                        <div class="col-lg-4 col-md-6 col-12">
                            <div class="single-table wow fadeInUp" data-wow-delay=".6s">
                                <div class="table-head">
                                    <h4 class="title">Doctor </h4>
                                    <p>All the basics for starting a new business</p>
                                    <div class="price">
                                <h2 class="amount">$24<span class="duration">/mo</span></h2>
                            </div>
                                    <div class="table-content">
                                        <h4 class="middle-title" style={{ textAlign: 'center', color: '#000', fontWeight: 'bold', marginBottom: '10px', textTransform: 'uppercase' }}>DOCTOR APPOINTMENTS</h4>
                                       <p style={{ textAlign: 'center', marginBottom: '20px' }}>
          Online booking for in-clinic and virtual doctor consultations.
        </p>
                                    </div>
                                    <div class="hero-content">
                                    <Grid item xs={12}>
                                        <div style={{ width: '100%', maxWidth: '270px', margin: '0 auto' }}>
                                            <FormControl className={classes.formControl} fullWidth="true"
                                            >
                                                <InputLabel id="demo-simple-select-label">Select Clinic ({clinicList.length})</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    name="clinicId"
                                                    label={`Select Clinic (${clinicList.length})`}

                                                    onChange={e => {
                                                        setClinicName(e.target.value.clinicName.toLowerCase());

                                                        setClinicId(e.target.value._id)
                                                    }}

                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>

                                                    {clinicList.map((clinicDet) => (
                                                        <MenuItem key={clinicDet._id} value={clinicDet}>{clinicDet.clinicName}

                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <br></br>
                                    <div class="button wow fadeInLeft" data-wow-delay=".8s" style={{ textAlign: 'center' }}>

                                        <a href="javascript:void(0)" class="btn" onClick={handleRedirectDoctor} style={{backgroundColor:'rgb(112, 57, 177)'}}><i class="lni lni-apple"></i> Book Your Appointment</a>
                                        <a href="javascript:void(0)" class="btn btn-alt"><i class="lni lni-play-store"></i> Google
Play</a>
                                    </div>
                                </div>
                                    <div class="button">
                                        <a href="javascript:void(0)" class="btn">Click Here</a>
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-12">
                            <div class="single-table wow fadeInUp" data-wow-delay=".6s">
                                <div class="table-head">
                                    <h4 class="title">Bank </h4>
                                    <p>All the basics for starting a new business</p>
                                    <div class="price">
                                <h2 class="amount">$32<span class="duration">/mo</span></h2>
                            </div>
                                    <div class="table-content">
                                        <h4 class="middle-title" style={{ textAlign: 'center', color: '#000', fontWeight: 'bold', marginBottom: '10px', textTransform: 'uppercase' }}>APPOINTMENT TOKEN PROCESS</h4>
                                        <p style={{ textAlign: 'center', marginBottom: '20px' }}>
                                        Designed for financial institutions to process loan applicant's appointments, generates token numbers and directs them to respective counter.
                                        </p>
                                    
                                    </div>
                                    <div class="hero-content">
                                    <Grid item xs={12}>
                                        <div style={{ width: '100%', maxWidth: '270px', margin: '0 auto' }}>
                                            <FormControl className={classes.formControl} fullWidth="true"
                                            >
                                                <InputLabel id="demo-simple-select-label">Select Bank Branch ({branchList.length})</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    name="branchId"
                                                    label={`Select Branch (${branchList.length})`}
                                                  
                                                    onChange={e => {
                                                        setBranchName(e.target.value.branchName.toLowerCase());
                                                        setBranchId(e.target.value._id)
                                                    }}

                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {branchList.map((branchDet) => (
                                                        <MenuItem key={branchDet._id} value={branchDet}>{branchDet.branchName}

                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <br></br>
                                    <div class="button wow fadeInLeft" data-wow-delay=".8s" style={{ textAlign: 'center' }}>

                                        <a href="javascript:void(0)" class="btn" onClick={handleRedirectBranch} style={{backgroundColor:'rgb(112, 57, 177)'}}><i class="lni lni-apple"></i> Book Your Appointment</a>
                                        <a href="javascript:void(0)" class="btn btn-alt"><i class="lni lni-play-store"></i> Google
Play</a>
                                    </div>
                                </div>
                                  
                                </div>

                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-12">
                            <div class="single-table wow fadeInUp" data-wow-delay=".8s">
                                <div class="table-head">
                            <h4 class="title">Museum</h4>
                            <p>All the basics for starting a new business</p>
                            <div class="price">
                                <h2 class="amount">$48<span class="duration">/mo</span></h2>
                            </div>
                            <div class="table-content">
                                        <h4 class="middle-title">What's Included</h4>
                                        <ul class="table-list">
                                            <li><i class="lni lni-checkmark-circle"></i> Cras justo odio.</li>
                                            <li><i class="lni lni-checkmark-circle"></i> Dapibus ac facilisis in.</li>
                                            <li><i class="lni lni-checkmark-circle"></i> Morbi leo risus.</li>
                                            <li><i class="lni lni-checkmark-circle"></i> Potenti felis, in cras ligula.</li>
                                        </ul>
                                    </div>
                            <div class="button">
                                        <a href="javascript:void(0)" class="btn">Click Here</a>
                                    </div>
                            </div>

                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-12">

                            <div class="single-table wow fadeInUp" data-wow-delay=".2s">

                                <div class="table-head">
                                    <h4 class="title">Organization </h4>
                                    <p>All the basics for starting a new business</p>
                                    <div class="price">
                                <h2 class="amount">$12<span class="duration">/mo</span></h2>
                            </div>
                                    <div class="table-content">
                                        <h4 class="middle-title">Organization</h4>
                                        <p>
                                        <p>Scan-Pay-Enter system for seamless access to parks, exhibitions, and events.</p>

                                        </p>
                                    </div>
                                    <div class="hero-content">
                                    <Grid item xs={6}>
                                        <div style={{ width: 270 }}>
                                            <FormControl className={classes.formControl} fullWidth="true"
                                            >
                                                <InputLabel id="demo-simple-select-label">Select Shows ({exbhitionList.length})</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    name="exbhitionId"
                                                    label={`Select Organization (${exbhitionList.length})`}
                                                  
                                                    onChange={e => {
                                                        setOrganizationName(e.target.value.organizationName.toLowerCase());
                                                        setExbhitionId(e.target.value._id)
                                                    }}

                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {exbhitionList.map((exbhitionDet) => (
                                                        <MenuItem key={exbhitionDet._id} value={exbhitionDet}>{exbhitionDet.organizationName}

                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <br></br>
                                    <div class="button wow fadeInLeft" data-wow-delay=".8s">

                                        <a href="javascript:void(0)" class="btn" onClick={handleRedirectExbhition} style={{backgroundColor:'rgb(112, 57, 177)'}}><i class="lni lni-apple"></i> Book Your Appointment</a>
                                        <a href="javascript:void(0)" class="btn btn-alt"><i class="lni lni-play-store"></i> Google
Play</a>
                                    </div>
                                </div>
                                    
                                </div>


                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-12">
                            <div class="single-table wow fadeInUp" data-wow-delay=".4s">
                                <div class="table-head">
                                    <h4 class="title">Coaching centre  </h4>
                                    <p>All the basics for starting a new business</p>
                                    <div class="price">
                                <h2 class="amount">$24<span class="duration">/mo</span></h2>
                            </div>
                                    <div class="table-content">
                                        <h4 class="middle-title">Coaching Centres & Gyms</h4>
                                        <p>            End-to-end online operations for coaching centres and gyms.
                                        </p>
                                    </div>
                                    <div class="button">

                                        <a href="javascript:void(0)" class="btn" style={{backgroundColor:'rgb(112, 57, 177)'}}>Click Here</a>
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-12">
                            <div class="single-table wow fadeInUp" data-wow-delay=".6s">
                                <div class="table-head">
                                    <h4 class="title">Feedback </h4>
                                    <p>All the basics for starting a new business</p>
                                    <div class="price">
                                <h2 class="amount">$32<span class="duration">/mo</span></h2>
                            </div>
                                    <div class="table-content">
                                        <h4 class="middle-title">Feedback Application</h4>
                                        <p> Feature for collecting customer feedback.</p>
                                    </div>
                                    <div class="button">
                                        <a href="javascript:void(0)" class="btn" style={{backgroundColor:'rgb(112, 57, 177)'}}>Click Here</a>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section> */}
            {/* <Container sx={{ py: 8 }}>
        <br></br>
        <br></br>
        <Typography variant="h4" align="center" gutterBottom>
        Why Choose Us
        </Typography>
        <br></br>
        <Grid container spacing={4} sx={{ mt: 4 }}>
         
          <Grid item xs={12} md={3}>
            <Box
              sx={{
                textAlign: "center",
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
              }}
              
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "rgba(112, 57, 177, 0.38)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
                <AccessAlarmIcon fontSize="medium"  />
              </Box>
              <Typography variant="h6" gutterBottom>
             No Queues
              </Typography>
              <Typography variant="body2">
              Skip long lines with instant access
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={3}>
            <Box
              sx={{
                textAlign: "center",
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "rgba(112, 57, 177, 0.38)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  
                  mb: 2,
                }}
              >
                               <PaymentIcon fontSize="medium" color="black" />

              </Box>
              <Typography variant="h6" gutterBottom>
              cashless transactions
              </Typography>
              <Typography variant="body2">
              Secure digital payments
              </Typography>
            </Box>
          </Grid>

        
          <Grid item xs={12} md={3}>
            <Box
              sx={{
                textAlign: "center",
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "rgba(112, 57, 177, 0.38)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
               <LocationOnIcon fontSize="medium" color="black" />

              </Box>
              <Typography variant="h6" gutterBottom>
              Multi-Location access
              </Typography>
              <Typography variant="body2">
             One platform to all events
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box
              sx={{
                textAlign: "center",
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "rgba(112, 57, 177, 0.38)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
               <CropFreeIcon fontSize="medium" color="black" />

              </Box>
              <Typography variant="h6" gutterBottom>
              Payment Integration
              </Typography>
              <Typography variant="body2">
              Secure online transaction processing
              </Typography>
            </Box>
          </Grid>
        </Grid>
     
       
      </Container> */}
            </>
        </>
    );
}

export default withRouter(Home);


